<template>
    <div>

        <div v-if="agregar" class="container-fluid">
            <div class="row">

                <div class="col-lg-12">
                    <div class="card box-margin">
                        <div class="card-header">
                            <i class="fas fa-th-large"></i><span> Cotizar</span>
                            <div class="btn-group" role="group">
                                <template v-if="AsignarRolPermisosByUsuario.includes('cotizacion.crear')">
                                    <button type="button" class="btn btn-primary" @click="agregarCoti"><i
                                            class="fas fa-plus-circle"></i>Agregar</button>
                                </template>
                                <template>
                                    <button type="button" class="btn btn-success" @click="abrilModalImpotarExcel()"><i
                                            class="fas fa-file-excel"></i> Importar</button>
                                </template>
                                <template>
                                    <button type="button" class="btn btn-info" @click="tranferencia()"><i
                                            class="fas fa-exchange-al"></i> Tranferir</button>
                                </template>
                                <template>
                                    <button type="button" class="btn btn-success" @click="cerrarlModalExport()"><i
                                            class="fas fa-file-excel"></i> Exportar</button>
                                </template>
                            </div>

                        </div>
                        <div class="card-body">

                            <el-collapse accordion class="hover-eti">
                                <el-collapse-item name="1" >
                                    <template slot="title">
                                        <h3><i class="el-icon-s-grid"></i> &nbsp; Lista de Filtros</h3>
                                    </template>
                                    <div class="form-group row">

                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="LeadName">Tipo Negocio</label>
                                                <select class="form-control rounded-0" v-model="filtro_tipo_negocio">
                                                    <option style="color:red;" value="0">Seleccione un tipo</option>
                                                    <option :value="1">Nuevo</option>
                                                    <option :value="2">Renovación</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="LeadName">Cliente</label>
                                                <input type="text" v-on:keyup.enter="getListCotizaciones(1, pag_mostrar)"
                                                    class="form-control" v-model="filtro_cliente" placeholder="Buscar...">
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="LeadName">Cédula</label>
                                                <input type="text" v-on:keyup.enter="getListCotizaciones(1, pag_mostrar)"
                                                    class="form-control" v-model="filtro_cedular" placeholder="Buscar...">
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="LeadName">Asesor</label>
                                                <select class="form-control" v-model="filtro_asesor"
                                                    style="border: 1px solid #727cf5; color: #000000;">
                                                    <option value="0">Seleccionar </option>
                                                    <option v-for="(asesor, index) in lista_asesor" :key="index"
                                                        :value="asesor.id" v-text="asesor.fullname"> </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="LeadName">Placa</label>
                                                <input type="text"
                                                    v-on:keyup.enter="getListCotizaciones(1, pag_mostrar)"
                                                    class="form-control"
                                                    v-model="filtro_placa" placeholder="Buscar...">
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="LeadName">Estado</label>
                                                <select class="form-control rounded-0" v-model="active_estado">
                                                    <option style="color:red;" value="0">Seleccione un estado</option>
                                                    <option v-for="es in estados_data" :key="es.name" :value="es.valor">
                                                        {{ es.name }}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="LeadName">Ramo</label>
                                                <select class="custom-select" v-model="filtro_ramo">
                                                    <option v-for="cla in lista_ramos" :key="cla.id" :value="cla.id"
                                                        v-text="cla.nombre"></option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="LeadName">Referencia</label>
                                                <select class="custom-select" v-model="filtro_referencia">
                                                    <option v-for="cla in aReferenciasList" :key="cla.id" :value="cla.id"
                                                        v-text="cla.nombre"></option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="fechames">Fecha</label>
                                                <input type="date" class="form-control" v-model="filtro_fecha">
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="fechames">Mes-Año</label>
                                                <input type="month" class="form-control" v-model="filtro_mes_anio">
                                            </div>
                                        </div>

                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="LeadName">Calificacion</label>
                                                <input type="number"
                                                    class="form-control" v-model="calificacion" @change="validateQuantityStars($event)">
                                            </div>
                                        </div>

                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="LeadName">Registros a mostrar</label>
                                                <input type="number" v-on:keyup.enter="getListCotizaciones(1, pag_mostrar)"
                                                    class="form-control" v-model="pag_mostrar">
                                            </div>
                                        </div>

                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="LeadName">Buscar</label>
                                                <button type="button" @click="getListCotizaciones(1, pag_mostrar)"
                                                    class="btn btn-primary form-control"><i class="fas fa-search"></i></button>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="LeadName">Limpiar</label>
                                                <button type="button" @click="limpiar_filtros()"
                                                    class="btn btn-primary form-control"><i
                                                        class="far fa-trash-alt"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>


                            <div class="shortcode-html">
                                <div style="overflow: auto !important;">
                                    <div class="breadcrumb">
                                        <a v-for="es in estados_data" :key="es.name" href="#"
                                            :class="es.clase + ' hoveractive ' + ((active_estado == es.valor) ? 'active' : '')"
                                            @click="activarHoveEstado(es.valor)">
                                            <div class="breadcrumb__inner">
                                                <span class="breadcrumb__title" v-text="es.cantidad"></span>
                                                <span class="breadcrumb__desc" v-text="es.name"></span>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <br>

                                <div class="table-responsive">

                                    <table class="table table-bordered table-hover" style="width:100% !important"
                                        id="ptable">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px !important;"><b>Acciones</b></th>
                                                <th><b>Fecha y Hora</b></th>
                                                <th><b>Clientes: <div class="badge badge-success text-white"> <b
                                                                style="color: white;" v-text="total_clientes"></b></div>
                                                    </b> </th>
                                                <th><b>Gestión</b></th>
                                                <th><b>Etiqueta</b></th>
                                                <th><b>U.Comentario</b></th>
                                                <th>
                                                    <b>Detalle: </b>
                                                    <div class="badge badge-success text-white"> <b
                                                            style="color: white;" v-text="'$' + total_sum_coti"></b>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody v-if="listCotizacion.length">
                                            <tr v-for="(c, index) in listCotizacion" :key="index">

                                                <td style="width: 50px !important;">
                                                    <div class="btn-group mb-2 mr-2">
                                                        <button type="button" class="btn btn-primary dropdown-toggle"
                                                            data-toggle="dropdown" aria-haspopup="true"
                                                            aria-expanded="false"><i class="fas fa-filter"></i>
                                                            Acción</button>
                                                        <div class="dropdown-menu">
                                                            <!--  && c.estado != 'PRELIQUIDACION' || usuario.cargo == 'Administrador' -->
                                                            <template
                                                                v-if="AsignarRolPermisosByUsuario.includes('cotizacion.editar')">
                                                                <button class="dropdown-item"
                                                                    @click="cargarEditarCotizacion(c.id)"><i
                                                                        class="fa fa-edit text-info"></i>
                                                                    Editar</button>
                                                            </template>

                                                            <template v-if="c.estado == 'PRELIQUIDACION' && AsignarRolPermisosByUsuario.includes('cotizacion.editar')">
                                                                <button class="dropdown-item"
                                                                    @click="cargarDatosCotizacion(c.id)"><i
                                                                        class="fa fa-certificate text-warning"></i>
                                                                    Renovación</button>
                                                            </template>

                                                            <template  v-if="AsignarRolPermisosByUsuario.includes('historial_cotizaciones.index')">
                                                                <button class="dropdown-item"
                                                                    @click="verHistorial(c.id_encrypt)"><i
                                                                        class="fa fa-file text-info"></i>
                                                                    Ver H.Cotizaciones</button>
                                                            </template>

                                                            <template
                                                                v-if="AsignarRolPermisosByUsuario.includes('cotizacion.eliminar') || usuario.cargo == 'Administrador'">
                                                                <button class="dropdown-item"
                                                                    @click="eliminarCotizacion(c.id)"><i
                                                                        class="fas fa-trash-alt text-danger"></i>
                                                                    Eliminar</button>
                                                            </template>

                                                            <template
                                                                v-if="AsignarRolPermisosByUsuario.includes('cotizacion.detalle')">
                                                                <button class="dropdown-item"
                                                                    @click="abrirModalDetalleCotizacion(c.id)"><i
                                                                        class="far fa-eye"></i> Ver</button>
                                                            </template>
                                                            <template
                                                                v-if="AsignarRolPermisosByUsuario.includes('cotizacion.pdf')">
                                                                <button class="dropdown-item"
                                                                    @click="cargarPdf(c.id)"><i
                                                                        class="far fa-file-pdf text-danger"></i> Ver
                                                                    PDF</button>
                                                            </template>

                                                            <template
                                                                v-if="AsignarRolPermisosByUsuario.includes('cotizacion.correo')">
                                                                <button class="dropdown-item"
                                                                    @click="enviar_correo(c.id)"><i
                                                                        class="fas fa-envelope text-success"></i> Enviar
                                                                    correo</button>
                                                            </template>

                                                            <template
                                                                v-if="AsignarRolPermisosByUsuario.includes('cotizacion.seguimiento') && c.estado != 'PRELIQUIDACION' || usuario.cargo == 'Administrador'">
                                                                <button class="dropdown-item"
                                                                    @click="seguimientoDetalle(c.id)"><i
                                                                        class="fas fa-file-invoice text-warning"></i>
                                                                    Seguimiento</button>
                                                            </template>
                                                            <template
                                                                v-if="AsignarRolPermisosByUsuario.includes('cotizacion.emitir')">
                                                                <button class="dropdown-item"
                                                                    @click="obtenerEmitirCotizacion(c.id)"><i
                                                                        class="fas fa-file-invoice text-primary"></i>
                                                                    Emitir</button>
                                                            </template>
                                                            <!-- <template>
                                                                <button class="dropdown-item"  @click="enviarWsp(c.telefono,c.cliente)"><i class="fab fa-whatsapp text-success"></i> Enviar Mensaje WSP</button>
                                                            </template> -->
                                                        </div>
                                                    </div>
                                                </td>

                                                <td>
                                                    <p style="font-weight: bold;" v-text="c.fecha_human"></p>
                                                    <p style="color: red; font-size: 15px;">AGREGADO EL:</p>
                                                    <p style="font-weight: bold;" v-text="c.fecha"></p>
                                                    <p style="font-weight: bold; font-size: 13px;" v-text="c.hora"></p>
                                                    <p style="color: red; font-size: 15px;">ÚLTIMA GESTIÓN:</p>
                                                    <p style="font-weight: bold;" v-text="c.ultima_fecha"></p>
                                                    <p style="font-weight: bold; font-size: 13px;"
                                                        v-text="c.ultima_hora"></p>
                                                    <p style="color: red; font-size: 15px;">VIGENCIA FIN:</p>
                                                    <p style="font-weight: bold;" v-text="c.fecha_vigencia_fin"></p>

                                                </td>

                                                <td>
                                                    <p>
                                                        <span style="font-weight: bold;" v-text="c.cliente"></span>
                                                        <calification
                                                        :calification="c.calificacion"
                                                        :index="index"
                                                        @selectCalification="selectCalification($event,c.id)"
                                                        >
                                                    </calification>
                                                    </p>

                                                    <p style="font-weight: bold;"> <a
                                                            :href="'mailto:' + c.cliente_email"
                                                            v-text="c.cliente_email"></a> </p>
                                                    <p><b style="color: blue; font-size: 16px;">Ref.</b> <span
                                                            style="font-weight: bold;" v-text="c.referencia"></span></p>
                                                    <p v-if="!usuario.cargo == 'Administrador'"><b
                                                            style="color: blue; font-size: 16px;">Asesor.</b> <span
                                                            style="font-weight: bold;" v-text="c.asesor"></span></p>
                                                    <p v-if="usuario.cargo == 'Administrador'">

                                                        <div class="d-flex align-items-center gap-1">
                                                            <b style="color: blue; font-size: 13px; white-space: nowrap;">Asesor:</b>
                                                            <select class="form-control form-control-sm" v-model="c.asesor_id"
                                                                    @change="cambiarAsesor(c.id, c.asesor_id)"
                                                                    style="border: 1px solid #727cf5; color: #000000; font-size: 12px; padding: 3px 5px; height: auto; width: 140px;">
                                                                <option v-for="(asesor, index) in lista_asesor" :key="index"
                                                                        :value="asesor.id" v-text="asesor.fullname"> </option>
                                                            </select>
                                                        </div>
                                                    </p>
                                                    <br>
                                                    <!--a class="btn btn-rounded btn-outline-success mb-2 mr-2"
                                                        v-for="(tel, index_tel) in c.telefonos" :key="index_tel"
                                                        :href="tel.wsp" target="_blank">
                                                        <i class="fab fa-whatsapp"></i>
                                                        {{ tel.telefono }}
                                                    </a-->
                                                <a class="d-inline-flex align-items-center mb-1 mr-2 text-success text-decoration-none"
                                                    v-for="(tel, index_tel) in c.telefonos" :key="index_tel"
                                                    :href="tel.wsp" target="_blank"
                                                    style="font-size: 13px; font-weight: 500; background: #e8f5e9; padding: 4px 10px; border-radius: 6px; border: 1px solid #c8e6c9; transition: 0.2s;">
                                                        <i class="fab fa-whatsapp mr-1" style="font-size: 15px;"></i>
                                                        {{ tel.telefono }}
                                                </a>

                                                </td>

                                            <!-- GESTION, AQUI colocar los 3 ultimos -->
                                                <td @click="seguimientoDetalle(c.id)">
                                                    <div class="badge badge-success text-white" v-if="c.vigencia == 1"
                                                        v-text="c.estado"></div>
                                                    <div class="badge badge-warning text-white"
                                                        v-else-if="c.vigencia == 2" v-text="c.estado"></div>
                                                    <div class="badge badge-danger text-white" v-else v-text="c.estado">
                                                    </div>

                                                    <ul class="list-unstyled mb-0 pl-0" style="max-height: 120px; overflow-y: auto; font-size: 0.85rem;">
                                                <!-- Segundo bucle para iterar los estados de esta cotización específica -->
                                                        <li v-for="seg in c.todos_seguimientos" :key="seg.id" class="border-bottom pb-1 mb-1">
                                                            <!-- Fecha y hora del cambio de estado -->
                                                            <small class="text-muted d-block font-weight-bold">
                                                                {{ seg.fecha }} - {{ seg.hora }}
                                                            </small>

                                                            <!-- Nombre del estado histórico en texto plano o badge pequeño -->
                                                            <span class="badge badge-secondary py-1 px-2 text-uppercase" style="font-size: 0.7rem;">
                                                                {{ seg.estado }}
                                                            </span>

                                                            <!-- Comentario descriptivo del asesor -->
                                                            <!--p class="mb-0 text-dark mt-1" style="font-size: 0.8rem; line-height: 1.2;">
                                                                {{ seg.comentario }}
                                                            </p-->
                                                        </li>

                                                <!-- Mensaje de protección si no cuenta con ningún historial -->
                                                <!--li v-if="!c.todos_seguimientos || c.todos_seguimientos.length === 0" class="text-muted small italic">
                                                    Sin seguimientos registrados
                                                </li-->
                                            </ul>






                                                </td>

                                                <td>
                                                    <p><b style="color: blue; font-size: 16px;">Antiguedad:</b> <span
                                                            style="font-weight: bold;" >{{ c.anio_antiguedad }} Años</span></p>
                                                    <p><b style="color: blue; font-size: 16px;">Tipo:</b> <span
                                                            style="font-weight: bold;" v-text="c.estado"></span></p>
                                                    <p class="ciruclo-p"><b style="font-size: 30px;">#</b> <span
                                                            style="font-weight: bold; font-size: 30px;"
                                                            v-text="c.seguimiento"></span></p>
                                                </td>
                                                <td style="font-weight: bold;" v-text="c.comentario"></td>
                                                <td>
                                                    <p><b style="color: blue; font-size: 16px;">Ramo:</b> <span
                                                            style="font-weight: bold;" v-text="c.ramo"></span></p>
                                                    <p><b style="color: blue; font-size: 16px;">B.A:</b> <span
                                                            style="font-weight: bold;" v-text="c.vehiculo"></span></p>
                                                    <p><b style="color: blue; font-size: 16px;">V.A</b> <span
                                                            style="font-weight: bold;" v-text="c.suma_asegurada"></span>
                                                    </p>
                                                    <p><b style="color: blue; font-size: 16px;">Precio</b> <span
                                                            style="font-weight: bold;" v-text="c.prima_neta"></span></p>
                                                    <p><b style="color: blue; font-size: 16px;">Empresa</b> <span
                                                            style="font-weight: bold;" v-text="c.empresa"></span></p>
                                                    <p><b style="color: blue; font-size: 16px;">Tipo Negocio:</b>
                                                        <span v-if="c.tipo_negocio != 0" v-text="c.tipo_negocio_text"
                                                            class="badge badge-success text-white"></span>
                                                        <span v-else v-text="c.tipo_negocio_text"
                                                            class="badge badge-danger text-white"></span>
                                                    </p>
                                                </td>

                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td colspan="12" align="center">
                                                    <h5>No se encontraron resultados...</h5>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <nav style="float: left;"> Mostrando la página <span
                                        v-text="pagination.current_page"></span> de <span
                                        v-text="pagination.last_page"></span></nav>
                                <nav style="float: right;">

                                    <ul class="pagination singel-page flex-wrap">
                                        <li class="page-item" v-if="pagination.current_page > 1">
                                            <a class="page-link"
                                                @click.prevent="cambiarPagina(pagination.current_page - 1)"
                                                href="#">Anterior</a>
                                        </li>
                                        <li class="page-item" v-for="page in pagesNumber" :key="page"
                                            :class="[page == isActived ? 'active' : '']">
                                            <a class="page-link" href="#" @click.prevent="cambiarPagina(page)"
                                                v-text="page"></a>
                                        </li>
                                        <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                                            <a class="page-link" href="#"
                                                @click.prevent="cambiarPagina(pagination.current_page + 1)">Siguiente</a>
                                        </li>
                                    </ul>
                                </nav>


                                <!-- End Table Bordered -->
                            </div>

                        </div>
                    </div>
                </div>


            </div>

             <!--   Inicio modal Detalle-------------------------------------------------------------------------------------------------------------------------------------->
             <div class="modal fade " :class="{ show: modal_exportar_datos }"
                :style="modal_exportar_datos ? mostrarModal : 'ocultarModal'">
                <div class="modal-dialog modal-md modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-header bg-info ">
                            <h5 class="modal-title mt-0 font-16 color-text-p" > Exportar Datos</h5>
                            <button type="button" @click="cerrarlModalExport" class="close color-text-p .close2"
                                data-dismiss="modal" aria-hidden="true">×</button>
                        </div>
                        <div class="modal-body">

                            <div class="col-md-12 col-lg-12 col-12">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="fechames">Mes-Año</label>
                                            <input type="month" class="form-control" v-model="filtro_mes_anio_export">
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th><b>Nombre</b></th>
                                                        <th><b>Seleccionar?</b></th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    <tr v-for="(c, index) in lista_datos_exportar" :key="index">
                                                        <td v-text="c.nombre"></td>
                                                        <td>
                                                            <vs-checkbox v-model="c.estado">
                                                                {{((c.estado == true)
                                                                ? 'SI' : 'NO')}}
                                                            </vs-checkbox>
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="modal-footer justify-content-between">
                            <label style="float: left;" for="" class="float-left"> </label>
                            <div>
                                <button type="button" @click="exportReport()" class="btn btn-sm btn-primary">Exportar</button>
                                <button type="button" class="btn btn-sm btn-secondary"  @click="cerrarlModalExport">Cerrar </button>
                            </div>
                        </div>

                    </div><!-- /.modal-content -->
                </div><!-- /.modal-dialog -->
            </div>

            <!--   Inicio modal Detalle-------------------------------------------------------------------------------------------------------------------------------------->
            <div class="modal fade " :class="{ show: modalShowDetalleCotizacion }"
                :style="modalShowDetalleCotizacion ? mostrarModal : 'ocultarModal'">
                <div class="modal-dialog modal-xl modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-header bg-info ">
                            <h5 class="modal-title mt-0 font-16 color-text-p" id="myLargeModalLabel">Detalle Cotización
                            </h5>
                            <button type="button" @click="cerrarModalDetalle" class="close color-text-p .close2"
                                data-dismiss="modal" aria-hidden="true">×</button>
                        </div>
                        <div class="modal-body">
                            <div class="col-md-12 col-lg-12">
                                <div class="card border mb-3">
                                    <div class="card-header">
                                        <b>Datos del Cliente</b>
                                    </div>
                                    <div class="card-body">

                                        <div class="row">
                                            <div class="col-md-4 col-lg-2">
                                                <div class="form-group">
                                                    <b><label>Cliente:</label></b>
                                                    <p v-text="arrayDetalleCotizacion.cliente"></p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-2">
                                                <div class="form-group">
                                                    <b><label>Edad:</label></b>
                                                    <p v-text="arrayDetalleCotizacion.edad"></p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-2">
                                                <div class="form-group">
                                                    <b><label>Cedula:</label></b>
                                                    <p v-text="arrayDetalleCotizacion.cedula"></p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-2">
                                                <div class="form-group">
                                                    <b><label>Telefono:</label></b>
                                                    <p v-text="arrayDetalleCotizacion.telefono_1"></p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-4">
                                                <div class="form-group">
                                                    <b><label>Telefono Secundario:</label></b>
                                                    <p v-text="arrayDetalleCotizacion.telefono_2"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 col-lg-12">
                                <div class="card border mb-3">
                                    <div class="card-header">
                                        <b>Datos del Vehículo</b>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-4 col-lg-4">
                                                <div class="form-group">
                                                    <b><label>Vehículo:</label></b>
                                                    <p v-text="arrayDetalleCotizacion.vehiculo"></p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-3">
                                                <div class="form-group">
                                                    <b><label>Placa:</label></b>
                                                    <p v-text="arrayDetalleCotizacion.placa"></p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-3">
                                                <div class="form-group">
                                                    <b><label>Año de Antiguedad:</label></b>
                                                    <p v-text="arrayDetalleCotizacion.anio_antiguedad"></p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-3">
                                                <div class="form-group">
                                                    <b><label>Marca:</label></b>
                                                    <p v-text="arrayDetalleCotizacion.marca"></p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-3">
                                                <div class="form-group">
                                                    <b><label>Categoria:</label></b>
                                                    <p v-text="arrayDetalleCotizacion.categoria"></p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-3">
                                                <div class="form-group">
                                                    <b><label>Clasificación:</label></b>
                                                    <p v-text="arrayDetalleCotizacion.clasificacion"></p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-3">
                                                <div class="form-group">
                                                    <b><label>Tipo de Uso:</label></b>
                                                    <p v-text="arrayDetalleCotizacion.tipo_uso"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 col-lg-12">
                                <div class="card border mb-3">
                                    <div class="card-header">
                                        <b>Datos Cotización</b>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">

                                            <div class="col-md-4 col-lg-3">
                                                <div class="form-group">
                                                    <b><label>Suma Asegurada:</label></b>
                                                    <p v-text="'$ ' + arrayDetalleCotizacion.suma_asegurada"></p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-3">
                                                <div class="form-group">
                                                    <b><label>Desgravamen:</label></b>
                                                    <p v-text="'$ ' + arrayDetalleCotizacion.desgravamen"></p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-3">
                                                <div class="form-group">
                                                    <b><label>Estado:</label></b>
                                                    <p v-text="arrayDetalleCotizacion.estado"></p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-3">
                                                <div class="form-group">
                                                    <b><label>Vigencia Inicio:</label></b>
                                                    <p v-text="arrayDetalleCotizacion.vigencia_inicio"></p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-3">
                                                <div class="form-group">
                                                    <b><label>Vigencia Fin:</label></b>
                                                    <p v-text="arrayDetalleCotizacion.vigencia_fin"></p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-3">
                                                <div class="form-group">
                                                    <b><label>Asesor:</label></b>
                                                    <p v-text="arrayDetalleCotizacion.asesor"></p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-3">
                                                <div class="form-group">
                                                    <b><label>Teleno del Asesor:</label></b>
                                                    <p v-text="arrayDetalleCotizacion.asesor_telefono"></p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-3">
                                                <div class="form-group">
                                                    <b><label>Registrado Por:</label></b>
                                                    <p v-text="arrayDetalleCotizacion.creado"></p>
                                                </div>
                                            </div>

                                            <div class="col-md-4 col-lg-3">
                                                <div class="form-group">
                                                    <b><label>Actualizado Por:</label></b>
                                                    <p v-text="arrayDetalleCotizacion.actualizado"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- --------------------------------------------------------------------------------------- -->
                            <h4>Lista de seguros cotizados</h4>
                            <!-- --------------------------------------------------------------------------------------- -->
                            <template>
                                <pdf-viewer @page-loaded="currentPage = $event" :pdf="url_pdf"></pdf-viewer>
                            </template>



                        </div>

                        <div class="modal-footer justify-content-between">
                            <label style="float: left;" for="" class="float-left"> </label>
                            <div>
                                <button type="button" class="btn btn-sm btn-secondary"
                                    @click="cerrarModalDetalle">Cerrar</button>
                            </div>
                        </div>

                    </div><!-- /.modal-content -->
                </div><!-- /.modal-dialog -->
            </div>
            <!--   Inicio modal Emitir-------------------------------------------------------------->
            <div class="modal fade " :class="{ show: modalShowEmitir }"
                :style="modalShowEmitir ? mostrarModal : 'ocultarModal'">
                <div class="modal-dialog modal-lg modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title mt-0 font-16" id="myLargeModalLabel">Emitir Cotizacion</h5>
                            <button type="button" @click="abrirModalEmitir" class="close" data-dismiss="modal"
                                aria-hidden="true">×</button>
                        </div>
                        <div class="modal-body">
                            <form>
                                <div class="card border">
                                    <div class="card-body">
                                        <div class="single-smart-card d-flex">
                                            <div class="text">
                                                <h5>ASEGURADO</h5>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName"> <b>Nombre Asegurado:</b> </label> <br>
                                                    <label v-text="emitir.asegurado_nombre"></label>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="usuarios"> <b>Cedula Asegurado:</b> </label><br>
                                                    <label v-text="emitir.asegurado_cedula"></label>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName"> <b>Télefono Asegurado:</b> </label> <br>
                                                    <label v-text="emitir.asegurado_telefono"></label>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName"> <b>Correo Asegurado:</b> </label> <br>
                                                    <label v-text="emitir.asegurado_correo"></label>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName"> <b>Dirección:</b> </label><br>
                                                    <label v-text="emitir.asegurado_direccion"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card border">
                                    <div class="card-body">
                                        <div class="single-smart-card d-flex">
                                            <div class="text">
                                                <h5>BENEFICIARIO</h5>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">Nombre Beneficiario</label>
                                                    <input type="text" class="form-control"
                                                        v-model="emitir.beneficiario_nombre"
                                                        placeholder="Ingresa Nombre del Beneficiario">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="usuarios">Cedula Beneficiario:</label>
                                                    <input type="text" class="form-control"
                                                        v-model="emitir.beneficiario_cedula"
                                                        placeholder="Ingrese número de cedula">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">Télefono Beneficiario:</label>
                                                    <input type="text" class="form-control"
                                                        v-model="emitir.beneficiario_telefono"
                                                        placeholder="Ingrese un Nº de Teléfono">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">Correo Asegurado:</label>
                                                    <input type="text" class="form-control"
                                                        v-model="emitir.beneficiario_correo"
                                                        placeholder="Ingresa un Correo Electrónico">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">Dirección:</label>
                                                    <input type="text" class="form-control"
                                                        v-model="emitir.beneficiario_direccion"
                                                        placeholder="Ingrese una Dirección">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card border">
                                    <div class="card-body">
                                        <div class="single-smart-card d-flex">
                                            <div class="text">
                                                <h5>SOLICITANTE</h5>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">Nombre Solicitante</label>
                                                    <input type="text" class="form-control"
                                                        v-model="emitir.solicitante_nombre"
                                                        placeholder="Ingrese nombre del solicitamte">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="usuarios">Cedula Solicitante:</label>
                                                    <input type="text" class="form-control"
                                                        v-model="emitir.solicitante_cedula"
                                                        placeholder="Ingrese número de cedula">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">Télefono Solicitante:</label>
                                                    <input type="text" class="form-control"
                                                        v-model="emitir.solicitante_telefono"
                                                        placeholder="Ingrese un Nº de teléfono">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">Correo Solicitante:</label>
                                                    <input type="text" class="form-control"
                                                        v-model="emitir.solicitante_correo"
                                                        placeholder="Ingresa un correo electrónico">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">Dirección:</label>
                                                    <input type="text" class="form-control"
                                                        v-model="emitir.solicitante_direccion"
                                                        placeholder="Ingrese una dirección">
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="card border">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="status-select" class="mr-2"><b>Emitir con:</b></label>
                                                    <select class="custom-select" v-model="emitir.emitir_id"
                                                        id="status-select-3-emitir">
                                                        <option value="0">Seleccionar</option>
                                                        <option v-for="doc in aTipoDocumento" :key="doc.id"
                                                            :value="doc.id" v-text="doc.tipo_doc"></option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName"><b>Detalle de Emision:</b></label>
                                                    <input type="text" class="form-control"
                                                        v-model="emitir.emicion_detalle"
                                                        placeholder="Ingrese un detalle">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card border">
                                    <div class="card-body">
                                        <div class="single-smart-card d-flex">
                                            <div class="text">
                                                <h5>DATOS DEL VEHICULO</h5>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName"> <b>Detalle del Vehículo (MARCA, MODELO,
                                                            AÑO)</b> </label> <br>
                                                    <label v-text="emitir.vehiculo_nombre"></label>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="usuarios"> <b>Placa:</b> </label><br>
                                                    <label v-text="emitir.vehiculo_placa"></label>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">Valor Segurado:</label>
                                                    <money v-bind="money" v-model="emitir.valor_asegurado"
                                                        class="form-control"></money>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName"> <b>Tasa de Casco:</b></label><br>
                                                    <label v-text="emitir.tasa_casco + ' %'"></label>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="card border">
                                    <div class="card-body">
                                        <div class="single-smart-card d-flex">
                                            <div class="text">
                                                <h5>DATOS DEL EXTRA</h5>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">Detalle</label> <br>
                                                    <input type="text" v-model="emitir.detalle" class="form-control"
                                                        placeholder="Ingrese un detalle">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="usuarios">Valor de Extra:</label><br>
                                                    <money v-bind="money" v-model="emitir.extra_valor"
                                                        class="form-control"></money>

                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName"> <b>Tasa de Extra</b> </label> <br>
                                                    <label v-text="emitir.extra_tasa + ' %'"></label>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="card border">
                                    <div class="card-body">
                                        <div class="single-smart-card d-flex">
                                            <div class="text">
                                                <h5>BENEFICIOS ADICIONALES</h5>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">Cero Deducible:</label> <br>
                                                    <input type="text" v-model="emitir.cero_deducible"
                                                        class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="usuarios">Auto Sustituto:</label><br>
                                                    <input type="text" v-model="emitir.auto_sustituto"
                                                        class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">Amparo Patrimonial:</label>
                                                    <input type="text" v-model="emitir.amparo_patrimonial"
                                                        class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">LucroCesante:</label>
                                                    <input type="text" v-model="emitir.lucro_cesante"
                                                        class="form-control">
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="card border">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName"><b>PRODUCTO:</b></label>
                                                    <input type="text" v-model="emitir.seguro_nombre"
                                                        class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName"><b>COTIZACION APROBADA:</b></label>
                                                    <input type="text" v-model="emitir.cotizacion_aprobada"
                                                        class="form-control">
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="card border">
                                    <div class="card-body">
                                        <div class="single-smart-card d-flex">
                                            <div class="text">
                                                <h5>OPCION DE PAGO</h5>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName"> <b>Valor a Cancelar:</b> </label> <br>
                                                    <label v-text="'$ ' + $formato_moneda(emitir.valor_cancelar)"></label>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="usuarios">Forma de Pago:</label><br>
                                                    <input type="text" v-model="emitir.forma_pago" class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">Comision Broker:</label>
                                                    <money v-bind="money" v-model="emitir.comision_broker"
                                                        class="form-control"></money>

                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">Número de Cuotas:</label>
                                                    <input type="text" v-model="emitir.numero_cuotas"
                                                        class="form-control">
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="card border">
                                    <div class="card-body">
                                        <div class="single-smart-card d-flex">
                                            <div class="text">
                                                <h5>FACTURA</h5>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">Factura a Favor:</label> <br>
                                                    <input type="text" v-model="emitir.factura_favor"
                                                        class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="status-select" class="mr-2"><b>Factura con:</b></label>
                                                    <select class="custom-select" v-model="emitir.factura_con"
                                                        id="status-select-3">
                                                        <option value="0">Seleccionar</option>
                                                        <option v-for="doc in aTipoDocumento" :key="doc.id"
                                                            :value="doc.id" v-text="doc.tipo_doc"></option>
                                                    </select>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="card border">
                                    <div class="card-body">
                                        <div class="single-smart-card d-flex">
                                            <div class="text">
                                                <h5>ENDOSO BENEFICIARIO </h5>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">Institucion:</label>
                                                    <input type="text" v-model="emitir.institucion"
                                                        class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">Ruc:</label>
                                                    <input type="text" v-model="emitir.ruc" class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">Monto:</label>
                                                    <money v-bind="money" v-model="emitir.monto" class="form-control">
                                                    </money>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="card border">
                                    <div class="card-body">
                                        <div class="single-smart-card d-flex">
                                            <div class="text">
                                                <h5>POLIZA DE VIDA</h5>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName"> <b>Monto:</b> </label> <br>
                                                    <label v-text="'$' + $formato_moneda(emitir.poliza_monto)"></label>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName"> <b>Tasa Requerida:</b> </label> <br>
                                                    <label v-text="emitir.poliza_tasa + '%'"></label>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName"> <b>Valor a Cancelar:</b></label> <br>
                                                    <label
                                                        v-text="'$' + $formato_moneda(emitir.poliza_valor_cancelar)"></label>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="LeadName">Endosado A:</label>
                                                    <input type="text" v-model="emitir.poliza_endoso"
                                                        class="form-control">
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="card border">
                                    <div class="card-body">
                                        <div class="single-smart-card d-flex">
                                            <div class="text">
                                                <h5>NOTAS ACLARATORIAS</h5>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <textarea class="form-control" v-model="emitir.notas"
                                                        rows="3"></textarea>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </form>
                        </div>

                        <div class="modal-footer">
                            <button type="button" v-if="emitir.beneficiario_id != 0" class="btn btn-sm btn-primary"
                                @click="pdfEmitir(emitir.id_cotizacion)">Pdf</button>
                            <button type="button" v-if="emitir.beneficiario_id != 0" class="btn btn-sm btn-primary"
                                @click="enviar_correo_emitir(emitir.id_cotizacion)">Enviar Corrreo</button>
                            <button type="button" class="btn btn-sm btn-primary"
                                @click="setRegistrarDatosEmitir">Guardar</button>
                            <button type="button" class="btn btn-sm btn-secondary"
                                @click="abrirModalEmitir">Cerrar</button>
                        </div>

                    </div><!-- /.modal-content -->
                </div><!-- /.modal-dialog -->
            </div>
            <!--   Fin modal Emitir-------------------------------------------------------------->

            <!--   Fin modal Detalle------------------------------------------------------------------------------------------------------------------------->
            <!--   Inicio modal Detalle-------------------------------------------------------------------------------------------------------------------------------------->
            <div class="modal fade " :class="{ show: modalShowSeguimiento }"
                :style="modalShowSeguimiento ? mostrarModal : 'ocultarModal'">
                <div class="modal-dialog modal-lg modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-header bg-info ">
                            <h5 class="modal-title mt-0 font-16 color-text-p" id="myLargeModalLabel">Seguimiento
                                Cotización</h5>
                            <button type="button" @click="cerrarModalSeguimiento" class="close color-text-p .close2"
                                data-dismiss="modal" aria-hidden="true">×</button>
                        </div>
                        <div class="modal-body">
                            <h6
                                v-text="cotizacion.cliente + ' - ' + cotizacion.vehiculo + ' - ' + cotizacion.vehiculo_anio">
                            </h6>
                            <ul class="nav nav-tabs" id="pills-tab" role="tablist">

                                <li class="nav-item" role="presentation">
                                    <a class="nav-link active" id="detalle-tab" data-toggle="pill" href="#detalle"
                                        role="tab" aria-controls="detalle" aria-selected="true"><i
                                            class="fas fa-file-contract"></i> Datos del Cliente</a>
                                </li>

                                <li class="nav-item" role="presentation">
                                    <a class="nav-link" id="tab-seguimiento-tab" data-toggle="pill"
                                        href="#tab-seguimiento" role="tab" aria-controls="tab-seguimiento"
                                        aria-selected="false"><i class="fas fa-file-medical-alt"></i> Seguimiento</a>
                                </li>

                                <li class="nav-item" role="presentation">
                                    <a class="nav-link" id="tab-agregar-tab" data-toggle="pill" href="#tab-agregar"
                                        role="tab" aria-controls="tab-agregar" aria-selected="true"><i
                                            class="fas fa-file-contract"></i> Agregar</a>
                                </li>

                            </ul>
                            <div class="tab-content" id="pills-tabContent">

                                <div class="tab-pane fade  show active" id="detalle" role="tabpanel"
                                    aria-labelledby="detalle-tab">
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12 col-lg-12">
                                            <table class="table">
                                                <tbody>
                                                    <tr>
                                                        <th scope="row"><b>Nombre y Apellido</b></th>
                                                        <td v-text="cotizacion.cliente"></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row"><b>Número de cédula o RUC</b></th>
                                                        <td v-text="cotizacion.cliente_num_doc"></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row"><b>Números de teléfono</b></th>
                                                        <td>
                                                            <a class="btn btn-rounded btn-outline-success mb-2 mr-2"
                                                                v-for="(tel, index_tel) in cotizacion.telefonos"
                                                                :key="index_tel" :href="tel.wsp" target="_blank">
                                                                <i class="fab fa-whatsapp"></i>
                                                                {{ tel.telefono }}
                                                            </a>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row"><b>Email</b></th>
                                                        <td v-text="cotizacion.cliente_email"></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row"><b>Marca de vehículo</b></th>
                                                        <td v-text="cotizacion.marca_vehiculo"></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row"><b>Modelo de vehículo</b></th>
                                                        <td v-text="cotizacion.modelo_vehiculo"></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row"><b>Año de vehículo </b></th>
                                                        <td v-text="cotizacion.vehiculo_anio"></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row"><b>Valor asegurado de vehículo</b></th>
                                                        <td v-text="cotizacion.suma_asegurada"></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row"><b>Prima neta de vehículo </b></th>
                                                        <td v-text="cotizacion.prima_neta"></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row"><b>Tasa de seguro </b></th>
                                                        <td v-text="cotizacion.tasa_seguro"></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row"><b>Seguro Cotizando </b></th>
                                                        <td v-text="cotizacion.empresa"></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row"><b>GPS</b></th>
                                                        <td v-text="cotizacion.dispositivo_rastreo"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div class="tab-pane fade" id="tab-seguimiento" role="tabpanel"
                                    aria-labelledby="tab-seguimiento-tab">
                                    <div
                                        class="kt-portlet kt-portlet--tabs kt-portlet--height-fluid scrollTableSeguimiento">
                                        <div class="kt-scroll ps ps--active-y" data-scroll="true"
                                            data-mobile-height="350">
                                            <!--Begin::Timeline -->
                                            <div v-for="(s, index) in arraySeguimiento" :key="index"
                                                class="kt-timeline">
                                                <!--Begin::Item -->
                                                <div
                                                    :class="'kt-timeline__item kt-timeline__item--' + [s.estado == 'VOLVER A LLAMAR' ? 'warning' : s.estado == 'NUMERO INCORRECTO' ? 'danger' : s.estado == 'NO DESEA' ? 'danger' : s.estado == 'AGENDAR' ? 'success' : 'brand']">

                                                    <div class="kt-timeline__item-section">
                                                        <div class="kt-timeline__item-section-border">
                                                            <div class="kt-timeline__item-section-icon">
                                                                <i v-if="s.estado == 'GESTION TELEFONICA'"
                                                                    class="fas fa-phone-square-alt text-success font-weight-bold"></i>
                                                                <i v-else-if="s.estado == 'VOLVER A LLAMAR'"
                                                                    class="fas fa-phone-volume text-warning font-weight-bold"></i>
                                                                <i v-else-if="s.estado == 'NUMERO INCORRECTO'"
                                                                    class="fas fa-phone-slash text-danger font-weight-bold"></i>
                                                                <i v-else-if="s.estado == 'NO DESEA'"
                                                                    class="fas fa-ban text-danger font-weight-bold"></i>
                                                                <i v-else-if="s.estado == 'AGENDAR'"
                                                                    class="far fa-address-book text-primary font-weight-bold"></i>
                                                                <i v-else-if="s.estado == 'CITA'"
                                                                    class="far fa-calendar-alt text-success font-weight-bold"></i>
                                                                <i v-else-if="s.estado == 'SEGUIMIENTO DE CIERRE'"
                                                                    class="fas fa-file-signature text-success font-weight-bold"></i>
                                                                <i v-else-if="s.estado == 'RECOLECION DE DOCUMENTOS'"
                                                                    class="fas fa-paste text-success font-weight-bold"></i>
                                                                <i v-else-if="s.estado == 'GESTION DE INSPECCION'"
                                                                    class="fas fa-search text-success font-weight-bold"></i>
                                                                <i v-else-if="s.estado == 'GESTION DE EMISION'"
                                                                    class="fab fa-searchengin text-success font-weight-bold"></i>
                                                                <i v-else-if="s.estado == 'GESTION DE LIBERACION'"
                                                                    class="fas fa-bullhorn text-success font-weight-bold"></i>
                                                                <i v-else
                                                                    class="fas fa-check-double text-success font-weight-bold"></i>
                                                            </div>
                                                        </div>
                                                        <span class="kt-timeline__item-datetime"
                                                            v-text="formatoFechaSeguimiento(s.created_at) + ' - ' + s.estado"></span>
                                                    </div>

                                                    <a class="kt-timeline__item-text"> <b>Vigencia inicio: </b>
                                                        <spa>
                                                            {{ formatoFechaSeguimiento(s.vigencia_inicio, 'D [de] MMMM [del]  YYYY') }}
                                                        </spa>
                                                    </a>
                                                    <a class="kt-timeline__item-text"> <b>Vigencia fin: </b>
                                                        <spa > {{ formatoFechaSeguimiento(s.vigencia_fin, 'D [de] MMMM [del]  YYYY') }}
                                                        </spa>
                                                    </a>
                                                    <br>
                                                    <a class="kt-timeline__item-text" v-text="s.comentario"></a>
                                                    <div class="kt-timeline__item-info"
                                                        v-if="s.file != null && s.file != ''">
                                                        <a :href="'storage/files/' + s.file" :download="s.file"
                                                            class="btn btn-link"><i class="fas fa-file-download"></i>
                                                            {{ s.file }}</a>

                                                    </div>

                                                    <div class="kt-timeline__item-info" v-if="s.url_file_preliquidacion != null && s.url_file_preliquidacion != ''">
                                                        <a :href="s.url_file_preliquidacion"  :download="getNombreArchivo(s.url_file_preliquidacion)"  class="btn btn-link"><i class="fas fa-file-download"></i>
                                                        PDF Preliquidación
                                                        </a>

                                                    </div>
                                                </div>
                                                <!--End::Item -->

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="tab-pane fade" id="tab-agregar" role="tabpanel"
                                    aria-labelledby="tab-agregar-tab">
                                    <div class="row">
                                        <div class="col-md-4 col-sm-4 col-lg-4">
                                            <div class="form-group">
                                                <label for="estado">Estado</label>
                                                <select class="custom-select" v-model="seguimiento.estado">
                                                    <option style="color:red;" value="0">Selecione un estado</option>
                                                    <option style="color:red;" value="GESTION TELEFONICA">Gestion
                                                        Telefonica</option>
                                                    <option style="color:red;" value="VOLVER A LLAMAR">Volver A Llamar
                                                    </option>
                                                    <option style="color:red;" value="NUMERO INCORRECTO">Numero
                                                        Incorrecto</option>
                                                    <option style="color:red;" value="NO DESEA">No Desea</option>
                                                    <option style="color:red;" value="AGENDAR">Agendar</option>
                                                    <option style="color:red;" value="CITA">Cita</option>
                                                    <option style="color:red;" value="SEGUIMIENTO DE CIERRE">Seguimiento
                                                        De Cierre</option>
                                                    <option value="RECOLECION DE DOCUMENTOS">Recolecion De Documentos
                                                    </option>
                                                    <option value="GESTION DE INSPECCION">Gestion De Inspeccion</option>
                                                    <option value="GESTION DE EMISION">Gestion De Emision</option>
                                                    <option value="GESTION DE LIBERACION">Gestion De Liberacion</option>
                                                    <option value="PRELIQUIDACION">Preliquidacion</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-sm-4 col-lg-4">
                                            <div class="form-group">
                                                <label for="LeadName">Vigencia Inicio</label>
                                                <input type="date" class="form-control"
                                                    v-model="seguimiento.fecha_inicio">

                                            </div>
                                        </div>

                                        <div class="col-md-4 col-sm-4 col-lg-4">
                                            <div class="form-group">
                                                <label for="LeadName">Vigencia Fin</label>
                                                <input type="date" class="form-control" v-model="seguimiento.fecha_fin">

                                            </div>
                                        </div>

                                        <div class="col-md-12 col-sm-12 col-lg-12">
                                            <div class="form-group">
                                                <label for="LeadName">Archivo</label>

                                                <input type="file" @change="obtenerfile" name="img_file" id="img_file"
                                                    accept=".doc,.docx,application/msword,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf, text/plain">

                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Comentario</label>

                                                <el-input type="textarea" placeholder="Comentario"
                                                    v-model="seguimiento.comentario" maxlength="255"
                                                    :autosize="{ minRows: 1.3, maxRows: 4 }" clearable show-word-limit>
                                                </el-input>
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-sm-12 col-lg-12">
                                            <button type="button" class="btn btn-success"
                                                @click="setRegistrarSeguimiento()">Registrar Seguimiento</button>
                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>

                        <div class="modal-footer justify-content-between">
                            <label style="float: left;" for="" class="float-left"> </label>
                            <div>
                                <button type="button" class="btn btn-sm btn-secondary"
                                    @click="cerrarModalSeguimiento">Cerrar</button>
                            </div>
                        </div>

                    </div><!-- /.modal-content -->
                </div><!-- /.modal-dialog -->
            </div>

            <div class="modal fade " :class="{ show: modalShowExcel }"
                :style="modalShowExcel ? mostrarModal : 'ocultarModal'">
                <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title mt-0 font-16">Importar Cotizaciones - Excel</h5>
                            <button type="button" @click="abrilModalImpotarExcel()" class="close" data-dismiss="modal"
                                aria-hidden="true">×</button>
                        </div>
                        <div class="modal-body">

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="LeadName">Archivo Excel</label>
                                        <input vue-load-file @change="fileUploadeExcel" class="form-control" type="file"
                                            id="file" accept=".XLSX">

                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="LeadName" class="text-danger"><b>Nota*</b></label>
                                        <p>- Solo se permiten archivos Excel de formato <b>.xlsx</b>, Click
                                            <a href="/cotizacion/exportar" download>aquÍ</a> para descargar archivo
                                            modelo.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="button" @click="importarExcel()" class="btn btn-sm btn-primary">Guardar</button>
                            <button type="button" class="btn btn-sm btn-secondary"
                                @click="abrilModalImpotarExcel()">Cerrar</button>
                        </div>

                    </div><!-- /.modal-content -->
                </div><!-- /.modal-dialog -->
            </div>

        </div>

        <div v-else class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card box-margin">
                        <div class="card-header">
                            <i class="fas fa-file-invoice"></i><span> Nueva Cotización</span>
                            <div class="btn-group" role="group">
                                <template v-if="AsignarRolPermisosByUsuario.includes('categoria.crear')">
                                    <button type="button" class="btn btn-primary" @click="agregarCoti"><i
                                            class="far fa-arrow-alt-circle-left"></i> Regresar</button>
                                    <button type="button" class="btn btn-success" @click="abrirModalCliente"><i
                                            class="fas fa-address-book"></i> Agregar Cliente</button>
                                </template>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="shortcode-html">
                                <div class="row border" style="padding-top:10px">

                                    <div class="col-md-4 col-sm-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Cliente</label>

                                            <v-select v-model="vaCreCoti.nombreCliente" @search="selectCliente"
                                                label="nombre" :options="arrayCliente" placeholder="Buscar Cliente..."
                                                @input="getDatosCliente">
                                                <span slot="no-options">Lo siento, no hay opciones coincidentes.</span>
                                            </v-select>
                                        </div>
                                    </div>

                                    <div class="col-md-2 col-sm-2 col-lg-2">
                                        <div class="form-group">
                                            <label>Edad</label>
                                            <input type="text" class="form-control bloquear" id="edad"
                                                v-model="vaCreCoti.edadCliente">
                                        </div>
                                    </div>


                                    <div class="col-md-2 col-sm-2 col-lg-2">
                                        <div class="form-group">
                                            <label for="tipo_negocio">Tipo Negocio</label>
                                            <select class="custom-select" v-model="vaCreCoti.tipo_negocio">
                                                <option value="0">Seleccionar</option>
                                                <option value="1">Nuevo</option>
                                                <option value="2">Renovación</option>
                                            </select>
                                        </div>
                                    </div>

                                    <!--Nuevas-->
                                    <div class="col-md-4 col-sm-4 col-lg-4">
                                        <div class="form-group">
                                            <label for="LeadName">Placa </label>
                                            <!--@input="consultarPlaca" -->
                                            <input  @keyup.enter="consultarPlacaAnt()"  :disabled="bloquear_input_placa" type="text" class="form-control" v-model="vaCreCoti.placa" style=" background: aliceblue; " placeholder="Ingrese un Nº de Placa">
                                        </div>
                                    </div>



                                    <div class="col-md-3 col-sm-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="LeadName">Marca </label> <br>
                                            <el-select class="bjar" v-model="vaCreCoti.idmarca" filterable
                                                @change="selectVehiculos(vaCreCoti.idmarca)" placeholder="Seleccionar">
                                                <el-option v-for="item in arrayMarcas" :key="item.id"
                                                    :label="item.nombre" :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>

                                    <div class="col-md-3 col-sm-3 col-lg-3">
                                        <div class="form-group">
                                            <label>Modelo</label> <br>
                                            <el-select class="bjar" v-model="vaCreCoti.idVehiculo" filterable

                                                placeholder="Seleccionar">
                                                <el-option v-for="item in arrayVehiculo" :key="item.id"
                                                    :label="item.nombre" :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>


                                    <div class="col-md-3 col-sm-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="anios">Año del Vehículo</label>
                                            <select class="custom-select" v-model="vaCreCoti.modelo_anios_id">
                                                <option value="0">Selecione un año</option>
                                                <option v-for="cla in arrayAnios" :key="cla.id" :value="cla.id"  v-text="cla.anio"></option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-3 col-sm-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="anios">Tipo Vehículo</label>
                                            <select class="custom-select" v-model="vaCreCoti.categoria_vehiculo">
                                                <option :value="0">Sin Asignar</option>
                                                <option :value="1">Liviano</option>
                                                <option :value="2">Pesado</option>
                                                <option :value="3">Camioneta</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-4 col-sm-4 col-lg-4">
                                        <div class="form-group">
                                            <label for="LeadName">Teléfono Alternativo </label>
                                            <input type="text" class="form-control" v-model="vaCreCoti.telefono_s"
                                                placeholder="Ingrese un Nº de Telefono">
                                        </div>
                                    </div>

                                    <div class="col-md-4 col-sm-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Año de Antiguedad</label>
                                            <input type="text" class="form-control" id="anio_antiguedad"
                                                v-model="vaCreCoti.anio_antiguedad">
                                        </div>
                                    </div>


                                    <div class="col-md-4 col-sm-4 col-lg-4">
                                        <div class="form-group">
                                            <label for="valor_mercados">Valor de mercado</label>
                                            <select class="custom-select" v-model="vaCreCoti.valor_mercados_id"
                                                @change="asignarValorMercado(vaCreCoti.valor_mercados_id)">
                                                <option value="0">Seleccione un valor de mercado</option>
                                                <option v-for="cla in arrayValorMercado" :key="cla.id" :value="cla.id"
                                                    v-text="cla.valor_mercado"></option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-4 col-sm-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Suma Asegurada</label>
                                            <money v-bind="money" v-model="vaCreCoti.suma_asegurada"
                                                class="form-control"></money>
                                        </div>
                                    </div>




                                    <div class="col-md-4 col-sm-4 col-lg-4">
                                        <div class="form-group">
                                            <label for="estado">Estado</label>
                                            <select class="custom-select" v-model="vaCreCoti.estado">
                                                <option style="color:red;" value="0">Selecione un estado</option>
                                                <option style="color:red;" value="GESTION TELEFONICA">Gestion Telefonica
                                                </option>
                                                <option style="color:red;" value="VOLVER A LLAMAR">Volver A Llamar
                                                </option>
                                                <option style="color:red;" value="NUMERO INCORRECTO">Numero Incorrecto
                                                </option>
                                                <option style="color:red;" value="NO DESEA">No Desea</option>
                                                <option style="color:red;" value="AGENDAR">Agendar</option>
                                                <option style="color:red;" value="CITA">Cita</option>
                                                <option style="color:red;" value="SEGUIMIENTO DE CIERRE">Seguimiento De
                                                    Cierre</option>
                                                <option value="RECOLECION DE DOCUMENTOS">Recolecion De Documentos
                                                </option>
                                                <option value="GESTION DE INSPECCION">Gestion De Inspeccion</option>
                                                <option value="GESTION DE EMISION">Gestion De Emision</option>
                                                <option value="GESTION DE LIBERACION">Gestion De Liberacion</option>
                                                <option value="PRELIQUIDACION">Preliquidacion</option>
                                            </select>
                                        </div>
                                    </div>


                                    <div class="col-md-4 col-sm-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Desgravamen</label>
                                            <money v-bind="money" v-model="vaCreCoti.desgravamen" class="form-control">
                                            </money>
                                            <!-- <input type="number" step="any" v-model="vaCreCoti.desgravamen" class="form-control" > -->
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-sm-4 col-lg-4">
                                        <div class="form-group">
                                            <label for="estado">Clasificación</label>
                                            <select class="custom-select" v-model="vaCreCoti.idClasificacion">
                                                <option value="0">Selecione una clasificación</option>
                                                <option v-for="cla in arrayClasificacion" :key="cla.id" :value="cla.id"
                                                    v-text="cla.nombre"></option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-sm-4 col-lg-4">
                                        <div class="form-group">
                                            <label for="Tipo">Tipo de Uso</label>
                                            <select class="custom-select" v-model="vaCreCoti.idTipoUso">
                                                <option value="0">Selecione una Tipo Uso</option>
                                                <option v-for="cla in arrayTipoUso" :key="cla.id" :value="cla.id"
                                                    v-text="cla.nombre"></option>

                                            </select>
                                        </div>
                                    </div>


                                    <div class="col-md-4 col-sm-4 col-lg-4">
                                        <div class="form-group">
                                            <label for="LeadName">Vigencia Inicio</label>
                                            <input type="date" class="form-control" v-model="vaCreCoti.fecha_inicio">

                                        </div>
                                    </div>

                                    <div class="col-md-4 col-sm-4 col-lg-4">
                                        <div class="form-group">
                                            <label for="LeadName">Vigencia Fin</label>
                                            <input type="date" class="form-control" v-model="vaCreCoti.fecha_fin">

                                        </div>
                                    </div>


                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Comentario</label>

                                            <el-input type="textarea" placeholder="Comentario"
                                                v-model="vaCreCoti.comentario" maxlength="255"
                                                :autosize="{ minRows: 1.3, maxRows: 4 }" clearable show-word-limit>
                                            </el-input>
                                        </div>
                                    </div>

                                    <div class="col-md-4 col-sm-4 col-lg-4">
                                        <div class="form-group">
                                            <label for="tipo_negocio">Ramo</label>
                                            <select class="custom-select" v-model="vaCreCoti.ramo_id">
                                                <option v-for="cla in lista_ramos" :key="cla.id" :value="cla.id"
                                                    v-text="cla.nombre"></option>

                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-4 col-sm-4 col-lg-4">
                                        <div class="form-group">
                                            <label for="LeadName">Nuevo seguro a cotizar</label>

                                            <button @click="abrirModal" type="button"
                                                class="btn btn-success form-control"><i class="fas fa-plus-circle"></i>
                                                Agregar Seguro a Cotizar</button>

                                        </div>
                                    </div>



                                    <div class="col-md-12 col-sm-12 col-lg-12 " align="center">
                                        <h3>ANÁLISIS CUANTITATIVOS - SEGUROS: VEHÍCULOS</h3>
                                    </div>
                                    <div class="container-fluid scrollTableCotizacion">
                                        <div class="row">
                                            <div class="col-md-6 col-sm-6 col-lg-6 " align="center"
                                                v-for="(c, index) in arrayCotizacion" :key="index">
                                                <el-collapse accordion>
                                                    <el-collapse-item :name="index">
                                                        <template slot="title">
                                                            <el-button type="danger"
                                                                @click="eliminar_Detalle_seguro(index, c?.id_cotizacion_seguro)"
                                                                icon="el-icon-delete" circle></el-button>
                                                            <el-divider direction="vertical"></el-divider>
                                                            {{ c.seguro.nombre }}
                                                            <i class="header-icon el-icon-information"></i>
                                                        </template>
                                                        <div class="table-responsive">
                                                            <table class="table table-bordered">
                                                                <tbody>

                                                                    <tr align="center">
                                                                        <th colspan="5" scope="colgroup"> <button
                                                                                type="button"
                                                                                @click="eliminar_Detalle_seguro(index, c?.id_cotizacion_seguro)"
                                                                                class="btn btn-danger btn-block"><i
                                                                                    class="fas fa-trash-alt"></i>
                                                                                Quitar</button> </th>

                                                                    </tr>
                                                                    <tr>
                                                                        <td ROWSPAN=3>
                                                                            <template>
                                                                                <div class="center">
                                                                                    <h4 for=""
                                                                                        style="color: red; font-weight: bold;">
                                                                                        Seleccionar? </h4>
                                                                                    <vs-checkbox
                                                                                        v-model="c.seleccionar">
                                                                                        {{((c.seleccionar == true) ? 'SI' :
                                                                                        'NO')}}
                                                                                    </vs-checkbox>
                                                                                </div>
                                                                            </template>
                                                                        </td>
                                                                        <th colspan="3" scope="colgroup"><b
                                                                                v-text="'Seguro:'"></b> <label
                                                                                v-text="'  ' + c.seguro.nombre"></label>
                                                                        </th>
                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="col"><b>Tasa</b></th>
                                                                        <th scope="col" colspan="2"><b>Prima Neta</b>
                                                                        </th>
                                                                    </tr>
                                                                    <tr>
                                                                        <!--  <th scope="col"  v-text="c.porcentaje_tasa + ' %'">3.20</th> -->
                                                                        <!-- <money v-bind="porcentaje_mo"
                                                                            v-model="c.porcentaje_tasa"
                                                                            class="form-control"></money> -->
                                                                        <input type="number" class="form-control" step="any" v-model="c.porcentaje_tasa" >
                                                                        <th scope="col" colspan="2"
                                                                            v-text="'$ ' + (vaCreCoti.suma_asegurada * c.porcentaje_tasa / 100)">
                                                                        </th>
                                                                    </tr>

                                                                    <tr>

                                                                        <th scope="row"><b>Desgravamen</b></th>
                                                                        <td v-text="c.seguro.desgravamen + ' %'"></td>
                                                                        <td colspan="2"
                                                                            v-text="'$ ' + (c.desgravamen = evaluar_des_por(vaCreCoti.desgravamen, c.seguro.desgravamen))">
                                                                        </td>

                                                                    </tr>
                                                                    <tr>

                                                                        <th scope="row"><b> Auto * Auto</b></th>
                                                                        <td style="width: 100px;">
                                                                            <template align="center">
                                                                                <div class="center">
                                                                                    <label for=""
                                                                                        style="color: red; font-weight: bold;">Aplica?
                                                                                    </label>
                                                                                    <vs-checkbox
                                                                                        v-model="c.auto_auto_aplica">
                                                                                        {{((c.auto_auto_aplica) ? 'SI' :
                                                                                        'NO')}}
                                                                                    </vs-checkbox>
                                                                                </div>
                                                                            </template>
                                                                        </td>
                                                                        <td v-text="'$ ' + c.seguro.auto_auto"
                                                                            style="width: 100px;"></td>
                                                                        <td v-text="((c.auto_auto_aplica) ? '$ ' + c.seguro.auto_auto : '')"
                                                                            style="width: 100px;"></td>



                                                                    </tr>
                                                                    <tr>
                                                                        <!-- <th scope="row"><b>0 Deducible</b></th>
                                                                                <td  colspan="3" v-text="'$ ' + c.seguro.cero_deducible">56</td> -->

                                                                        <th scope="row"><b> 0 Deducible</b></th>
                                                                        <td style="width: 100px;">
                                                                            <template align="center">
                                                                                <div class="center">
                                                                                    <label for=""
                                                                                        style="color: red; font-weight: bold;">Aplica?
                                                                                    </label>
                                                                                    <vs-checkbox
                                                                                        v-model="c.deducible_aplica">
                                                                                        {{((c.deducible_aplica) ? 'SI' :
                                                                                        'NO')}}
                                                                                    </vs-checkbox>
                                                                                </div>
                                                                            </template>
                                                                        </td>
                                                                        <td v-text="c.seguro.cero_deducible + '%'"
                                                                            style="width: 100px;"></td>
                                                                        <td v-if="c.deducible_aplica"
                                                                            v-text="'$ ' + (c.deducible_total = ((c.seguro.cero_deducible * vaCreCoti.suma_asegurada / 100)).toFixed(2))"
                                                                            style="width: 100px;"></td>
                                                                        <td v-else v-text="c.deducible_total = 0"
                                                                            style="width: 100px;"></td>

                                                                    </tr>
                                                                    <tr>
                                                                        <!-- <th scope="row"><b>Amparo Patrimonial</b></th>
                                                                                <td  colspan="3" v-text="'$ ' + c.seguro.amparo_patrimonial">56</td> -->

                                                                        <th scope="row"><b> Amparo Patrimonial</b></th>
                                                                        <td style="width: 100px;">
                                                                            <template align="center">
                                                                                <div class="center">
                                                                                    <label for=""
                                                                                        style="color: red; font-weight: bold;">Aplica?
                                                                                    </label>
                                                                                    <vs-checkbox
                                                                                        v-model="c.amparo_patrimonial_aplica">
                                                                                        {{((c.amparo_patrimonial_aplica)
                                                                                        ? 'SI' : 'NO')}}
                                                                                    </vs-checkbox>
                                                                                </div>
                                                                            </template>
                                                                        </td>
                                                                        <td v-text="c.seguro.amparo_patrimonial + '%'"
                                                                            style="width: 100px;"></td>
                                                                        <td v-if="c.amparo_patrimonial_aplica"
                                                                            v-text="'$ ' + (c.amparo_patrimonial_total = ((c.seguro.amparo_patrimonial * vaCreCoti.suma_asegurada / 100)).toFixed(2))"
                                                                            style="width: 100px;"></td>
                                                                        <td v-else
                                                                            v-text="c.amparo_patrimonial_total = 0"
                                                                            style="width: 100px;"></td>


                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="row"><b>Dispositivo de rastreo</b>
                                                                        </th>
                                                                        <td style="width: 100px;">
                                                                            <template align="center">
                                                                                <div class="center">
                                                                                    <label for=""
                                                                                        style="color: red; font-weight: bold;">Aplica?
                                                                                    </label>
                                                                                    <vs-checkbox
                                                                                        v-model="c.dis_rastreo_aplica">
                                                                                        {{((c.dis_rastreo_aplica == true)
                                                                                        ? 'SI' : 'NO')}}
                                                                                    </vs-checkbox>
                                                                                </div>
                                                                            </template>
                                                                        </td>
                                                                        <td colspan="2"
                                                                            v-text="'$ ' + c.seguro.dispositivo_rastreo">
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="col"> </th>
                                                                        <th scope="col"> <b>P .Neta:</b> </th>
                                                                        <th scope="col" colspan="2"
                                                                            v-text="arrayPrimaNeta[index].prima_neta = calcularPrimaNeta(c)">
                                                                        </th>
                                                                    </tr>
                                                                    <tr align="center">
                                                                        <th class="table-primary" scope="row"
                                                                            colspan="4"><b>Cobertura</b></th>
                                                                    </tr>
                                                                    <tr v-for="d in c.covertura" :key="d.id">
                                                                        <td scope="row" v-text="d.nombre"></td>
                                                                        <td colspan="3" align="center"
                                                                            v-if="d.tipo_variable == 'TEXTO' && d.descripcion != ''"
                                                                            v-text="d.descripcion"></td>
                                                                        <td colspan="3" align="center"
                                                                            v-else-if="d.tipo_variable == 'MONTO' && d.monto != 0"
                                                                            v-text="'US$ ' + d.monto"></td>
                                                                        <td colspan="3" align="center"
                                                                            v-else-if="d.tipo_variable == 'PORCENTAJE'"
                                                                            v-text="d.monto + '%'"></td>
                                                                        <td colspan="3" align="center" v-else><i
                                                                                class="fas fa-check"></i></td>

                                                                    </tr>
                                                                    <tr align="center">
                                                                        <th class="table-primary" scope="row"
                                                                            colspan="4"><b>Deducible</b></th>
                                                                    </tr>
                                                                    <tr v-for="d in c.deducible" :key="d.id">
                                                                        <td scope="row" v-text="d.nombre"></td>
                                                                        <td colspan="3" align="center"
                                                                            v-if="d.tipo_variable == 'TEXTO' && d.descripcion != ''"
                                                                            v-text="d.descripcion"></td>
                                                                        <td colspan="3" align="center"
                                                                            v-else-if="d.tipo_variable == 'MONTO' && d.monto != 0"
                                                                            v-text="'US$ ' + d.monto"></td>
                                                                        <td colspan="3" align="center"
                                                                            v-else-if="d.tipo_variable == 'PORCENTAJE'"
                                                                            v-text="d.monto + '%'"></td>
                                                                        <td colspan="3" align="center" v-else><i
                                                                                class="fas fa-check"></i></td>

                                                                    </tr>
                                                                    <tr>
                                                                        <td><b>PRIMA NETA:</b></td>

                                                                        <th scope="col" colspan="3"
                                                                            v-text="'$ ' + arrayPrimaNeta[index].prima_neta">
                                                                        </th>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><b>SUPER BANCOS:</b></td>
                                                                        <td colspan="2">
                                                                         <!--    <money v-bind="porcentaje_mo"
                                                                                v-model="c.s_bancos_por"
                                                                                class="form-control"></money> -->
                                                                                <input type="number" class="form-control" step="any" v-model="c.s_bancos_por" >
                                                                        </td>
                                                                        <td
                                                                            v-text="c.s_bancos = (arrayPrimaNeta[index].prima_neta * c.s_bancos_por / 100).toFixed(2)">
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><b>S. CAMPESINO:</b></td>
                                                                        <td colspan="2">
                                                                            <input type="number" step="any"   v-model="c.s_campesino_por"   class="form-control" >
                                                                        <!--
                                                                            <money v-bind="porcentaje_mo"
                                                                                v-model="c.s_campesino_por"
                                                                                class="form-control"></money> -->
                                                                        </td>
                                                                        <td
                                                                            v-text="c.s_campesino = (arrayPrimaNeta[index].prima_neta * c.s_campesino_por / 100).toFixed(2)">
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td> <b>S.S.C. NO COBRADO (2001 - 2007):</b>
                                                                        </td>
                                                                        <td colspan="2"></td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><b>DERECHOS DE EMISION:</b> </td>

                                                                        <td colspan="3" align="center"
                                                                            v-text="c.derecho_emicion = evaluar_derecho_emicion(arrayPrimaNeta[index].prima_neta)">
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><b>INTERES DE FINANCIACION: </b></td>
                                                                        <td colspan="2">
                                                                           <!--  <money v-bind="porcentaje_mo"
                                                                                v-model="c.interes_financiamiento_por"
                                                                                class="form-control"></money> -->

                                                                                <input type="number" step="any"   v-model="c.interes_financiamiento_por"  class="form-control" >
                                                                        </td>
                                                                        <td
                                                                            v-text="c.interes_financiamiento = ((arrayPrimaNeta[index].prima_neta + parseFloat(c.s_bancos) + parseFloat(c.derecho_emicion) + parseFloat(c.s_campesino)) * c.interes_financiamiento_por / 100).toFixed(2)">
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><b>IVA:</b></td>
                                                                        <td v-text="c.iva_por + ' %'" colspan="2"></td>
                                                                        <td v-if="c.interes_financiamiento != 0"
                                                                            v-text="c.iva_total = (parseFloat(c.interes_financiamiento) + parseFloat(c.s_bancos) + parseFloat(c.derecho_emicion) + parseFloat(c.s_campesino)).toFixed(2)">
                                                                        </td>
                                                                        <td v-else
                                                                            v-text="c.iva_total = ((arrayPrimaNeta[index].prima_neta + parseFloat(c.s_bancos) + parseFloat(c.derecho_emicion) + parseFloat(c.s_campesino)) * c.iva_por / 100).toFixed(2)">
                                                                        </td>
                                                                    </tr>
                                                                    <tr align="center">
                                                                        <th class="table-primary" scope="row"
                                                                            colspan="4"><b>CON DESCUENTO</b></th>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><b>VALOR A PAGAR VEHICULO:</b></td>

                                                                        <td v-if="c.interes_financiamiento != 0"
                                                                            colspan="3"
                                                                            v-text="'US$ ' + (c.valor_pagar_vehiculo = (arrayPrimaNeta[index].prima_neta + parseFloat(c.iva_total) + 10).toFixed(2))">
                                                                        </td>
                                                                        <td v-else colspan="3"
                                                                            v-text="'US$ ' + (c.valor_pagar_vehiculo = (arrayPrimaNeta[index].prima_neta + parseFloat(c.s_bancos) + parseFloat(c.s_campesino) + parseFloat(c.derecho_emicion) + parseFloat(c.iva_total)).toFixed(2))">
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><b>DESGRAVAMEN:</b></td>

                                                                        <td colspan="3" v-text="'US$ ' + c.desgravamen">
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><b>VALOR A PAGAR VEHICULO + DESGRAVAMEN +
                                                                                DISPOSITIVO RASTREO:</b></td>

                                                                        <td colspan="3"
                                                                            v-text="'US$ ' + ((c.dis_rastreo_aplica == true) ? (c.total = parseFloat(c.valor_pagar_vehiculo) + parseFloat(c.desgravamen) + parseFloat(c.seguro.dispositivo_rastreo)).toFixed(2) : (c.total = parseFloat(c.valor_pagar_vehiculo) + parseFloat(c.desgravamen)).toFixed(2))">
                                                                        </td>

                                                                    </tr>

                                                                    <!--   <tr  align="center">
                                                                                <th class="table-primary" scope="row" colspan="3"><b>CON DESCUENTO</b></th>
                                                                            </tr>
                                                                            <tr>
                                                                                <td><b>DESC A CONTADO VEHICULO</b></td>
                                                                                <td>34</td>
                                                                                <td>34</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td><b>DESGRAVAMEN:</b></td>
                                                                                <td>34</td>
                                                                                <td>34</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td><b>VALOR A PAGAR VEHICULO + DESGRAV:</b></td>
                                                                                <td>34</td>
                                                                                <td>34</td>
                                                                            </tr> -->


                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </el-collapse-item>
                                                </el-collapse>


                                            </div>
                                        </div>

                                    </div>

                                </div>


                                <br>
                                <div class="row">
                                    <div class="col-12">
                                        <button type="button" class="btn btn-primary" @click="agregarCoti()"><i
                                                class="far fa-arrow-alt-circle-left"></i> Regresar</button>
                                        <button type="button" v-if="registrar_actualizar == 1" class="btn btn-success"
                                            @click="registrarCotizacion()">Registrar Cotización</button>
                                        <button type="button" v-if="registrar_actualizar == 2" class="btn btn-success"
                                            @click="actualizarCotizacion()">Actualizar Cotización</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!--   Inicio modal Usuario-------------------------------------------------------------->
            <div class="modal fade " :class="{ show: modalShow }" :style="modalShow ? mostrarModal : 'ocultarModal'">
                <div class="modal-dialog modal-md modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title mt-0 font-16" id="myLargeModalLabel" v-text="tituloModal"></h5>
                            <button type="button" @click="abrirModal" class="close" data-dismiss="modal"  aria-hidden="true">×
                            </button>
                        </div>
                        <div class="modal-body">
                            <form>
                                <div class="row">

                                    <div class="col-md-12 col-sm-12 col-lg-12">
                                        <div class="form-group">
                                            <label>Seguro</label>

                                            <v-select multiple v-model="nombreSeguro" label="nombre"
                                                :options="arraySeguro" placeholder="Buscar Seguro...">
                                                <span slot="no-options">Lo siento, no hay opciones coincidentes.</span>
                                            </v-select>
                                        </div>
                                    </div>

                                    <div class="col-md-12 col-sm-12 col-lg-12">
                                        <div class="form-group">
                                            <label for="estado">Tasas</label>
                                            <!-- <select class="custom-select" v-model="idTasaSeguro">
                                                <option value="0">Selecione una Tasa</option>
                                            </select> -->
                                          <!--   <money v-bind="porcentaje_mo" v-model="tasa_automatico"
                                                class="form-control">
                                            </money> -->

                                            <input type="number" step="any"  v-model="tasa_automatico"
                                                class="form-control" >

                                        </div>
                                    </div>


                                </div>

                            </form>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-sm btn-primary"
                                @click="tasas_seguro_agregar()">Agregar</button>
                            <button type="button" class="btn btn-sm btn-secondary" @click="abrirModal">Cerrar</button>
                        </div>

                    </div><!-- /.modal-content -->
                </div><!-- /.modal-dialog -->
            </div>


            <!--   Inicio modal Cliente-------------------------------------------------------------->
            <div class="modal fade " :class="{ show: modalShowCliente }"
                :style="modalShowCliente ? mostrarModal : 'ocultarModal'">
                <div class="modal-dialog modal-xl  modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title mt-0 font-16" id="myLargeModalLabel" v-text="tituloModal"></h5>
                            <button type="button" @click="abrirModalCliente" class="close" data-dismiss="modal"
                                aria-hidden="true">×</button>
                        </div>
                        <div class="modal-body">
                            <form>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="LeadName">Nombre</label>
                                            <input type="text" class="form-control" id="name"
                                                v-model="vaCreCliente.cNombre" placeholder="Ingresa Nombre del Cliente">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="LeadName">Apellido</label>
                                            <input type="text" class="form-control" id="apellido"
                                                v-model="vaCreCliente.cApellido"
                                                placeholder="Ingresa Apellido del Cliente">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="status-select" class="mr-2">Documento</label>
                                            <select class="custom-select" @change="consultarDatos()" v-model="vaCreCliente.eIdDocumento"
                                                id="status-select-12">
                                                <option v-for="doc in aTipoDocumento" :key="doc.id" :value="doc.id"
                                                    v-text="doc.tipo_doc"></option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="usuarios">N° Documento</label>
                                            <input :disabled="bloquar_input_natural"  type="text" style="background: aliceblue;"
                                                @input="consultarDatos()"  class="form-control" v-model="vaCreCliente.cNumDoc"
                                                placeholder="Ingrese número de documento"
                                            >
                                                <label id="cname-error" class="error mt-2 text-danger" for="cname" v-if="document.estado" v-text="document.error"></label>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="LeadName">Dirección</label>
                                            <input type="text" class="form-control" id="direccion"
                                                v-model="vaCreCliente.cDireccion" placeholder="Ingrese una Dirección">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="LeadName">Correo Electrónico</label>
                                            <input type="text" class="form-control" id="correo"
                                                v-model="vaCreCliente.cEmail"
                                                placeholder="Ingresa un Correo Electrónico">
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="LeadName">Teléfono </label>
                                            <input type="text" class="form-control"
                                                v-model="vaCreCliente.cTelefonoCliente"
                                                placeholder="Ingrese un Nº de Teléfono">
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="LeadName">Fecha Nacimiento </label>
                                            <input type="date" class="form-control"
                                                v-model="vaCreCliente.fecha_nacimiento">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="status-select" class="mr-2">Referencias</label>
                                            <select class="custom-select" v-model="vaCreCliente.referencia"
                                                id="status-select">
                                                <option v-for="red in aReferenciasList" :key="red.id" :value="red.id"
                                                    v-text="red.nombre"></option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="status-select" class="mr-2">Actividad Economica</label>
                                            <select class="custom-select" v-model="vaCreCliente.idactividad_economica"
                                                id="status-select">
                                                <option v-for="red in aActividadEconomicaList" :key="red.id"
                                                    :value="red.id" v-text="red.nombre"></option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="LeadName">Nombre Conyugue</label>
                                            <input type="text" class="form-control" id="name_conyugue"
                                                v-model="vaCreCliente.nombre_conyugue"
                                                placeholder="Ingresa Nombre del Conyugue">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="LeadName">Apellido Conyugue</label>
                                            <input type="text" class="form-control" id="apellido_conyugue"
                                                v-model="vaCreCliente.apellido_conyugue"
                                                placeholder="Ingresa Apellido del Conyugue">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="status-select" class="mr-2">Estado Civil</label>
                                            <select class="custom-select" v-model="vaCreCliente.estado_civil"
                                                id="status-select">

                                                <option value="Soltero">Soltero</option>
                                                <option value="Casado">Casado</option>
                                                <option value="Divorciado">Divorciado</option>
                                                <option value="Unión libre">Unión libre</option>

                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="LeadName">Fecha Nacimiento Conyugue</label>
                                            <input type="date" class="form-control"
                                                v-model="vaCreCliente.fecha_nacimiento_conyugue">
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="LeadName">Cantidad de Hijos</label>
                                            <input type="number" min="0" class="form-control" id="hijos"
                                                v-model="vaCreCliente.hijos_cantidad">
                                        </div>
                                    </div>

                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="LeadName">Edad Conyugue</label>
                                            <input type="text" class="form-control" id="edad_conyugue"
                                                :value="calcularEdad(vaCreCliente.fecha_nacimiento_conyugue)">
                                        </div>
                                    </div>

                                </div>
                            </form>

                            <form class="g-brd-around g-brd-gray-light-v4">
                                <h4>Nombre de los Hijos</h4>
                                <hr class="g-brd-gray-light-v4 g-mx-minus-30">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="LeadName">Nombre</label>
                                            <input type="text" class="form-control" id="name_hijo"
                                                v-model="dataHijosConyugues.nombre" placeholder="Ingresar Nombre">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="LeadName">Apellido</label>
                                            <input type="text" class="form-control" id="apellido_hijo"
                                                v-model="dataHijosConyugues.apellido" placeholder="Ingresar Apellido">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="LeadName">Fecha Nacimiento </label>
                                            <input type="date" class="form-control"
                                                v-model="dataHijosConyugues.fecha_nacimiento">
                                        </div>
                                    </div>
                                    <div class="col-md-12 text-right">
                                        <button type="button" class="btn btn-success mb-2 mr-2"
                                            @click="agregarHijosConyugue()">Agregar</button>
                                    </div>
                                </div>
                                <div class="table-responsive" style="padding-top: 10ox">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Eliminar</th>
                                                <th>Nombre</th>
                                                <th>Apellido</th>
                                                <th>Cumpleaños</th>
                                                <th>Edad</th>
                                            </tr>
                                        </thead>

                                        <tbody v-if="listHijosConyugue.length">
                                            <tr v-for="(c, index) in listHijosConyugue" :key="index">
                                                <td>
                                                    <button type="button" @click="eliminar_hijo(index)"
                                                        class="btn btn-danger btn-block"><i
                                                            class="fas fa-trash-alt"></i> Quitar</button>
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" v-model="c.nombre"
                                                        placeholder="Ingresar Nombre">
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" v-model="c.apellido"
                                                        placeholder="Ingresar Apellido">
                                                </td>
                                                <td>
                                                    <input type="date" class="form-control" v-model="c.cumpleanio">
                                                </td>
                                                <td>{{ calcularEdad(c.cumpleanio) }} Años</td>
                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td colspan="10" align="center">
                                                    <h5>No se encontraron resultados...</h5>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </form>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-sm btn-primary"
                                @click="setRegistrarCliente">Guardar</button>
                            <button type="button" class="btn btn-sm btn-secondary"
                                @click="abrirModalCliente">Cerrar</button>
                        </div>

                    </div><!-- /.modal-content -->
                </div><!-- /.modal-dialog -->
            </div>
            <!--   Fin modal Cliente-------------------------------------------------------------->




        </div>

        <tranferencia-modal @onClose="getListCotizaciones(1, pag_mostrar)"></tranferencia-modal>
    </div>
</template>

<script>

import { alertasM } from '../../../util.js';
import PdfViewer from "vue-pdf-app";
import Tranferencia from './componentes/Tranferrencia.vue';
import calification from './componentes/calification.vue';
export default {
    props: ['ruta', 'iva_data'],
    components: {
        'PdfViewer': PdfViewer,
        'tranferencia-modal': Tranferencia,
        'calification': calification
    },
    data() {
        return {
            nombrebuscarmodelo:'',
            buscarmodelo:false,
            loading: false,
            vehiculo: null,
            calificacion: 0,
            cCriterio: 'cliente',
            cBusqueda: '',
            listCotizacion: [],
            pagination: {
                'total': 0,
                'current_page': 0,
                'per_page': 0,
                'last_page': 0,
                'from': 0,
                'to': 0,
            },
            offset: 3,
            pag_mostrar: 5,//registros a mostrar por pagina tipo datable
            modalShow: false,
            modalShowCliente: false,
            modalShowDetalleCotizacion: false,
            mostrarModal: {
                display: 'block',
                background: '#0000006b'
            },
            ocultarModal: {
                display: 'none'
            },

            tituloModal: '',
            AsignarRolPermisosByUsuario: JSON.parse(localStorage.getItem('listRolPermisosByUsuario')),
            agregar: true,
            arrayCliente: [],//cliente
            arrayVehiculo: [],//vehiculo
            arrayClasificacion: [],//clasificacion
            arrayAnios: [],//Años
            arrayValorMercado: [],//clasificacion
            arraySeguro: [],//Seguro
            arrayTasas: [],//Tasas
            arrayTipoUso: [],//Tasas
            lista_ramos: [],//ramos
            arrayCoberturas: [],
            arrayDeducibles: [],
            arrayVersiones: [],
            arrayMarcas: [],
            vaCreCoti: {

                idcliente: 0,
                nombreCliente: '',
                edadCliente: 0,
                suma_asegurada: 0.0,
                idVehiculo: null,
                estado: 0,
                idClasificacion: 0,
                fecha_inicio: null,
                fecha_fin: null,
                modelo_anios_id: 0,
                valor_mercados_id: 0,
                desgravamen: 0.0,
                idTipoUso: 0.0,
                placa: '',
                telefono_s: '',
                comentario: '',
                iduser: 0,
                anio_antiguedad: 0,
                tipo_negocio: 0,
                idmarca: null,
                ramo_id: 1,
                fecha_nacimiento: null,
                categoria_vehiculo : 0,
                anio_vehiculo : 0,
            },
            idasesor: null,
            nombreAswsor: null,

            money: {
                decimal: ',',
                thousands: '.',
                prefix: '$ ',
                suffix: '',
                precision: 2,
                masked: false
            },

            porcentaje_mo: {
                decimal: '.',
                thousands: '',
                prefix: '',
                suffix: ' %',
                precision: 13,
                masked: false
            },
            nombreSeguro: '',
            idSeguro: 0,
            arrayCotizacion: [],
            arrayPrimaNeta: [],
            arrayDetalle: [],
            //Crear Cliente
            vaCreCliente: {
                eId: 0,
                cNombre: '',
                cApellido: '',
                fecha_nacimiento: null,
                cNumDoc: '',
                eIdDocumento: 1,
                cDireccion: '',
                cTelefonoCliente: '',
                cEmail: '',
                referencia: 0,
                idactividad_economica: 0,
                estado_civil: '',
                hijos_cantidad: 0,
                nombre_conyugue: '',
                apellido_conyugue: '',
                fecha_nacimiento_conyugue: null,
            },
            dataHijosConyugues: {
                id: 0,
                nombre: '',
                apellido: '',
                fecha_nacimiento: null
            },
            listHijosConyugue: [],
            aTipoDocumento: [],
            aReferenciasList: [],
            aActividadEconomicaList: [],
            //Detalle View
            arrayDetalleCotizacion: [],
            url_pdf: null,
            idCotizacion: null,
            registrar_actualizar: 1, //1registrar 2 actualziar
            actualizar_seguros: false,//si hay algun seguro seleccionado entonces e no se edita, si no hay seguros, si se edita
            //Seguimiento
            modalShowSeguimiento: false,
            arraySeguimiento: [],
            seguimiento: {
                id: 0,
                estado: 0,
                fecha_inicio: '',
                fecha_fin: '',
                comentario: '',
                file: '',
            },
            form: new FormData,

            bloquear_seguros: false,// al editar verificamos si hay un seguro seleccionado. de ser asi, entonces se bloquea
            usuario: [],
            tasa_automatico: 0,
            modalShowEmitir: false,
            emitir: {
                /*Asegurado */
                id_cliente: 0,
                asegurado_nombre: '',
                asegurado_cedula: '',
                asegurado_telefono: '',
                asegurado_correo: '',
                asegurado_direccion: '',
                /*Beneficiario */
                beneficiario_id: 0,
                beneficiario_nombre: '',
                beneficiario_cedula: '',
                beneficiario_telefono: '',
                beneficiario_correo: '',
                beneficiario_direccion: '',
                /*Solicitante */
                solicitante_id: 0,
                solicitante_nombre: '',
                solicitante_cedula: '',
                solicitante_telefono: '',
                solicitante_correo: '',
                solicitante_direccion: '',

                emitir_id: 0,//Tipo de documento
                emicion_detalle: '',

                /*datos vehiculo */
                id_vehiculo: 0,
                vehiculo_nombre: '',
                vehiculo_placa: '',
                valor_asegurado: 0.0,
                tasa_casco: 0.0,
                /*Datos Extras */
                detalle: '',
                extra_valor: 0.0,
                extra_tasa: 0.0,
                /*Beneficios adicionales*/
                cero_deducible: 'NO',
                auto_sustituto: 'NO',
                amparo_patrimonial: 'NO',
                lucro_cesante: 'NO',
                /*producto */
                id_seguro: 0,
                seguro_nombre: 0,
                cotizacion_aprobada: '',
                /*Opciones de pago */
                valor_cancelar: 0.0,
                forma_pago: 'CONTADO',
                comision_broker: 0.0,
                numero_cuotas: '',

                /*Factura*/
                factura_favor: '',
                factura_con: 0,

                /*Endoso beneficiario */
                institucion: '',
                ruc: '',
                monto: 0.0,

                /*Poliza de vida */
                poliza_monto: 0.0,
                poliza_tasa: 0.0,
                poliza_valor_cancelar: 0.0,
                poliza_endoso: '',
                /*Notas */
                notas: '',
                id_cotizacion: 0,
            },
            estados_data: [],
            active_estado: '0',
            //Filtros
            filtro_cliente: '',
            filtro_cedular: '',
            filtro_asesor: 0,
            filtro_ramo: null,
            filtro_placa: '',
            filtro_referencia: 0,
            filtro_fecha: null,
            filtro_mes_anio: null,
            filtro_tipo_negocio: 0,
            modalShowExcel: false,
            excel_cotizacion: '',
            cotizacion: {},
            lista_asesor: [],
            total_clientes: 0,
            total_sum_coti: 0,

            //Exportar

            lista_datos_exportar : [
                {
                    'nombre'    : 'Nombre Cliente',
                    'valor'     : 'nombre',
                    'estado'    : false,
                    'columna'   : 'A',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Apellido Cliente',
                    'valor'     : 'apellido',
                    'estado'    : false,
                    'columna'   : 'B',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Tipo Documento',
                    'valor'     : 'tipo_documento',
                    'estado'    : false,
                    'columna'   : 'C',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'N° Documento',
                    'valor'     : 'numero_documento',
                    'estado'    : false,
                    'columna'   : 'D',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'F.Nacimiento',
                    'valor'     : 'fecha_nacimiento',
                    'estado'    : false,
                    'columna'   : 'E',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Dirección',
                    'valor'     : 'direccion',
                    'estado'    : false,
                    'columna'   : 'F',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Email',
                    'valor'     : 'email',
                    'estado'    : false,
                    'columna'   : 'G',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Teléfono',
                    'valor'     : 'telefono',
                    'estado'    : false,
                    'columna'   : 'H',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Teléfono 2 ',
                    'valor'     : 'telefono_2',
                    'estado'    : false,
                    'columna'   : 'I',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Teléfono 3',
                    'valor'     : 'telefono_3',
                    'estado'    : false,
                    'columna'   : 'J',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Referencia',
                    'valor'     : 'referencia',
                    'estado'    : false,
                    'columna'   : 'K',
                    'espacio'   : 20,
                },
                {
                    'nombre'    : 'Tipo Aplacamiento',
                    'valor'     : 'tipo_aplacamiento',
                    'estado'    : false,
                    'columna'   : 'L',
                    'espacio'   : 20,

                },
                {
                    'nombre'    : 'Actividad Económica',
                    'valor'     : 'actividad_economica',
                    'estado'    : false,
                    'columna'   : 'M',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Tipo Cliente',
                    'valor'     : 'tipo_cliente',
                    'estado'    : false,
                    'columna'   : 'N',
                    'espacio'   : 20,
                },
                {
                    'nombre'    : 'Marca',
                    'valor'     : 'marca',
                    'estado'    : false,
                    'columna'   : 'O',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Modelo Vehículo',
                    'valor'     : 'modelo_vehiculo',
                    'estado'    : false,
                    'columna'   : 'P',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Año Vehículo',
                    'valor'     : 'anio_vehiculo',
                    'estado'    : false,
                    'columna'   : 'RQ',
                    'espacio'   : 15,
                },
                {
                    'nombre'    : 'Valor Mercado',
                    'valor'     : 'valor_mercado',
                    'estado'    : false,
                    'columna'   : 'R',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Placa',
                    'valor'     : 'placa',
                    'estado'    : false,
                    'columna'   : 'S',
                    'espacio'   : 20,
                },
                {
                    'nombre'    : 'Estado',
                    'valor'     : 'estado',
                    'estado'    : false,
                    'columna'   : 'T',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Clasificación',
                    'valor'     : 'clasificacion',
                    'estado'    : false,
                    'columna'   : 'U',
                    'espacio'   : 25,
                },
                {
                    'nombre'    : 'Tipo Uso',
                    'valor'     : 'tipo_uso',
                    'estado'    : false,
                    'columna'   : 'V',
                    'espacio'   : 25,
                },
                {
                    'nombre'    : 'Tipo Negocio',
                    'valor'     : 'tipo_negocio',
                    'estado'    : false,
                    'columna'   : 'W',
                    'espacio'   : 25,
                },
                {
                    'nombre'    : 'Seguro',
                    'valor'     : 'seguro',
                    'estado'    : false,
                    'columna'   : 'X',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Ramo',
                    'valor'     : 'ramo',
                    'estado'    : false,
                    'columna'   : 'Y',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : '% Tasa',
                    'valor'     : 'tasa',
                    'estado'    : false,
                    'columna'   : 'Z',
                    'espacio'   : 10,
                },
                {
                    'nombre'    : 'Aplica Auto x Auto',
                    'valor'     : 'aplica_auto_x_auto',
                    'estado'    : false,
                    'columna'   : 'AA',
                    'espacio'   : 10,
                },
                {
                    'nombre'    : 'Aplica Cero Deducible',
                    'valor'     : 'aplica_cero_deducible',
                    'estado'    : false,
                    'columna'   : 'AB',
                    'espacio'   : 10,
                },
                {
                    'nombre'    : 'Aplica Amparo Patrimonial',
                    'valor'     : 'aplica_amparo_patrimonial',
                    'estado'    : false,
                    'columna'   : 'AC',
                    'espacio'   : 10,
                },
                {
                    'nombre'    : 'Aplica Dispositivo de rastreo',
                    'valor'     : 'aplica_dispositivo_rastreo',
                    'estado'    : false,
                    'columna'   : 'AD',
                    'espacio'   : 10,
                },

            ],
            modal_exportar_datos: false,
            filtro_mes_anio_export : null,
            bloquar_input_natural : false,
            document: {
                error : '',
                estado : false,
            },
            bloquear_input_placa : false,
        }
    },
    mixins: [alertasM],

    computed: {
        isActived: function () {
            return this.pagination.current_page;
        },
        //Calcula los elementos de la paginación
        pagesNumber: function () {
            if (!this.pagination.to) {
                //si la pagina es diferente al ultimo elemento de la pagina actual, retornamos
                return []; //Array vacio
            }

            var from = this.pagination.current_page - this.offset;
            // console.log("bengy: ", from);
            if (from < 1) {
                //si la pagina actual es 0 entonces la igualamos  a uno
                from = 1;
            }
            //la suma de la variable rom + el doble de la varialbe offset
            var to = from + this.offset * 2;
            // console.log("bengy2: ", from);
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }

            var pagesArray = [];
            while (from <= to) {
                /*   pagesArray.push(from);//Ocurre desbordamiento, cuando son muchos registros
                            from++; */
                //Solucion
                if (
                    (from >= this.pagination.current_page - 1) &
                    (from <= this.pagination.current_page + 3)
                )
                    pagesArray.push(from);
                from++;
            }
            return pagesArray;
        },

    },
    methods: {

        validateQuantityStars($event){
            var valor = $event.target.value;
            if(valor > 5){
                this.calificacion = 5;
            }

        },
        getListCotizaciones(page, pag_mostrar) {
            var url = '/cotizacion';
            this.openCargando();//Activamos pantalla de carga de bloqueo
            axios.get(url, {
                params: {
                    'estado': this.active_estado,
                    'cliente': this.filtro_cliente,
                    'cedular': this.filtro_cedular,
                    'asesor': this.filtro_asesor,
                    'placa': this.filtro_placa,
                    'referencia': this.filtro_referencia,
                    'ramo': this.filtro_ramo,
                    'fecha_cotizacion': this.filtro_fecha,
                    'mes_cotizacion': this.filtro_mes_anio,
                    'tipo_negocio': this.filtro_tipo_negocio,
                    'page': page,
                    'pag_mostrar': pag_mostrar,
                    'calificacion': this.calificacion
                }
            })
                .then(res => {

                    var respuesta = res.data;
                    this.estados_data = respuesta.estados;
                    this.listCotizacion = respuesta.cotizacion;
                    this.pagination = respuesta.pagination;
                    this.total_clientes = respuesta.cliente_count;
                    this.total_sum_coti = respuesta.cliente_sum;
                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                })
                .catch(error => {
                    this.openCargando(true);
                    if (error.response.status == 401) {
                        if (localStorage['authUser']) {
                            this.$router.push({ name: 'login' })
                            location.reload();
                            localStorage.clear();
                            this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                        }
                    }
                    console.error(error);
                })

        },

        cambiarPagina(page, buscar, criterio) {
            let me = this;
            //Actualiza la página actual
            me.pagination.current_page = page;
            //Envia la petición para visualizar la data de esa página
            me.getListCotizaciones(page, me.pag_mostrar);
        },

        agregarCoti() {
            this.agregar = !this.agregar;

            if (this.agregar == true) {
                this.getListCotizaciones(1, this.pag_mostrar);
                this.registrar_actualizar = 1

            } else {
                //this.selectVehiculo('',false,1)
                this.selectCliente('', false, 1)
                this.selectsGroup()//clasificacion y anios y valores
                //this.getSelectTipoUso()
                //this.getSelectCobeDedu()
                this.registrar_actualizar = 1
            }
            this.cleanVariables();
        },

        //Busqueda del cliente
        selectCliente(search, loading, defecto) {
            let me = this;
            var url = '/cotizacion/getlistcliente';

            if (defecto == null) {
                loading(true)
                axios.get(url, { params: { 'filtro': search } })
                    .then(function (response) {
                        let respuesta = response.data;
                        q: search
                        me.arrayCliente = respuesta;
                        loading(false)
                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.status == 401) {
                            if (localStorage['authUser']) {
                                this.$router.push({ name: 'login' })
                                location.reload();
                                localStorage.clear();
                            }
                        }
                    });
            } else {

                axios.get(url, { params: { 'filtro': search } })
                    .then(function (response) {
                        let respuesta = response.data;
                        me.arrayCliente = respuesta;

                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.status == 401) {
                            if (localStorage['authUser']) {
                                this.$router.push({ name: 'login' })
                                location.reload();
                                localStorage.clear();
                            }
                        }
                    });

            }
        },

        getDatosCliente(val1) {
            let me = this;

            if (val1 == null) {
                me.vaCreCoti.idcliente = 0;
                me.vaCreCoti.nombreCliente = "";
                me.vaCreCoti.edadCliente = 0;
                me.vaCreCoti.fecha_nacimiento = 0;
            } else {

                me.loading = true;
                me.vaCreCoti.idcliente = val1.id;
                me.vaCreCoti.nombreCliente = val1.nombre;
                me.vaCreCoti.edadCliente = val1.edad;
                me.vaCreCoti.fecha_nacimiento = val1.fecha_nacimiento;
            }
        },

        async selectsGroup() {
            let me = this;
            try {
                var url = '/cotizacion/selects';

                let response = await axios.get(url);
                var respuesta = response.data;
                this.arrayClasificacion = respuesta.clasificacion;
                this.arrayAnios = respuesta.anio;
                this.arrayValorMercado = respuesta.valor_mercado;
                this.arrayTipoUso = respuesta.tipo_uso;
                this.arrayCoberturas = respuesta.cobertura;
                this.arrayDeducibles = respuesta.deducible;
                this.arrayMarcas = respuesta.marcas;


            } catch (error) {
                console.log(error);
                if (error.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({ name: 'login' })
                        location.reload();
                        localStorage.clear();
                    }
                }

            }
        },

        async selectVehiculos(idmarca)
        {
            let me = this;
            try {
                var url = '/cotizacion/select-vehiculos';
                let get = {
                    'marca_id': idmarca,
                };

                let response = await axios.get(url, { params: get });
                var respuesta = response.data;
                this.arrayVehiculo = respuesta.vehiculo;

               // console.log("array Vehiculo asincronico: "+respuesta.vehiculo);
                if (this.buscarmodelo)
                {
                  //  this.arrayVehiculo.forEach(vehiculo => console.log(vehiculo));

                    const existe_m = this.arrayVehiculo.find(m => m.nombre.toUpperCase().includes(this.nombrebuscarmodelo.toUpperCase().trim()));

                    if(existe_m){
                        //GTB1585
                        this.vaCreCoti.idVehiculo = existe_m.id
                           console.log("existe modelo del carro  :"+existe_m.id);
                    }else{
                           console.log("no existe modelo del carro  :");

                    }
                }

                this.buscarmodelo=false;


                this.arrayVersiones = [];

            } catch (error) {
                console.log(error);
                if (error.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({ name: 'login' })
                        location.reload();
                        localStorage.clear();
                    }
                }

            }
        },

        async selectVersiones(id_modelo) {
            let me = this;
            try {
                var url = '/cotizacion/select-versiones';
                let get = {
                    'modelo_id': id_modelo
                };

                let response = await axios.get(url, { params: get });
                var respuesta = response.data;
                this.arrayVersiones = respuesta.version;

            } catch (error) {
                console.log(error);
                if (error.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({ name: 'login' })
                        location.reload();
                        localStorage.clear();
                    }
                }

            }
        },

        abrirModal() {
            this.modalShow = !this.modalShow;

            if (this.modalShow == true) {

                this.tituloModal = "Agregar Cotizacion";
                this.tasa_automatico = this.calcular_tasas(this.vaCreCoti.edadCliente, this.vaCreCoti.anio_antiguedad, this.vaCreCoti.suma_asegurada);
                this.selectTipoSeguro('', false, 1)


            } else {

            }
        },

        //Busqueda del tipo seguro
        selectTipoSeguro(search, loading, defecto) {

            let me = this;
            var url = '/cotizacion/getlisttiposeguro';

            if (defecto == null) {
                loading(true)
                axios.get(url, { params: { 'filtro': search } })
                    .then(function (response) {
                        let respuesta = response.data;
                        q: search
                        me.arraySeguro = respuesta;
                        loading(false)
                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.status == 401) {
                            if (localStorage['authUser']) {
                                this.$router.push({ name: 'login' })
                                location.reload();
                                localStorage.clear();
                            }
                        }
                    });
            } else {

                axios.get(url, { params: { 'filtro': search } })
                    .then(function (response) {
                        let respuesta = response.data;
                        me.arraySeguro = respuesta;

                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.status == 401) {
                            if (localStorage['authUser']) {
                                this.$router.push({ name: 'login' })
                                location.reload();
                                localStorage.clear();
                            }
                        }
                    });

            }

        },


        //Agregamos el seguro a cotizar
        async tasas_seguro_agregar() {
            var me = this;
            // me.openCargando();

            if ((me.nombreSeguro.length) <= 0) {
                // me.openCargando(true);
                me.notify(" Seleccione almenos un seguro", "", "top", "right", "fas fa-exclamation-triangle", "danger", ' flipInX', 'flipOutX')
                return
            }
            me.openCargando();

            if(this.validarDatosSweaden()){
                me.openCargando(true);
                return ;
            }

            me.nombreSeguro.forEach(async element => {

                if(element.id == 2 || element.id == 15){

                    var url = '/consulta/sweaden';

                    let post = {
                        'id'                : element.id,
                        'suma_aseg'         : this.vaCreCoti.suma_asegurada,
                        'anio_vehiculo'     : this.vaCreCoti.anio_vehiculo,
                        'categoria'         : this.vaCreCoti.categoria_vehiculo,
                        'fec_invig'         : this.vaCreCoti.fecha_inicio,
                        'fec_finvig'        : this.vaCreCoti.fecha_fin,
                        'fec_nacimiento'    : this.vaCreCoti.fecha_nacimiento,
                    };

                    try {

                        let response        = await axios.post(url,post);
                        var respuesta       = response.data;

                        if(!respuesta.success){
                            this.notify(respuesta.message, "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')
                            return;
                        }else{

                            var aux = respuesta.data

                            me.arrayCotizacion.push({
                            seguro                      : aux.seguro,
                            dis_rastreo_aplica          : false,
                            deducible                   : aux.deducible,
                            covertura                   : aux.covertura,
                            porcentaje_tasa             : aux.tasa,
                            auto_auto_aplica            : false,
                            deducible_aplica            : false,
                            amparo_patrimonial_aplica   : false,
                            deducible_total             : 0.00,
                            amparo_patrimonial_total    : 0.00,
                            interes_financiamiento_por  : 0,
                            interes_financiamiento      : 0,
                            derecho_emicion             : 0,
                            s_bancos_por                : 3.50,
                            s_bancos                    : 0,
                            s_campesino_por             : 0.50,
                            s_campesino                 : 0,
                            iva_por                     : this.iva_data,
                            iva_total                   : 0,
                            valor_pagar_vehiculo        : 0,
                            desgravamen                 : 0,
                            total                       : 0,
                            seleccionar                 : false,

                        });

                        me.arrayPrimaNeta.push({
                            prima_neta: 0
                        });
                        }


                    } catch (error) {
                        console.error(error)
                        me.openCargando(true);
                        return ;
                    }


                }else{
                    var url = '/cotizacion/getlistSeguroTotal';

                    axios.post(url, { 'id': element.id }).then(res => {
                        var respuesta = res.data;

                        me.arrayCotizacion.push({
                            seguro                      : respuesta.seguro,
                            dis_rastreo_aplica          : false,
                            deducible                   : respuesta.deducible,
                            covertura                   : respuesta.covertura,
                            porcentaje_tasa             : me.tasa_automatico,
                            auto_auto_aplica            : false,
                            deducible_aplica            : false,
                            amparo_patrimonial_aplica   : false,
                            deducible_total             : 0.00,
                            amparo_patrimonial_total    : 0.00,
                            interes_financiamiento_por  : 0,
                            interes_financiamiento      : 0,
                            derecho_emicion             : 0,
                            s_bancos_por                : 3.50,
                            s_bancos                    : 0,
                            s_campesino_por             : 0.50,
                            s_campesino                 : 0,
                            iva_por                     : this.iva_data,
                            iva_total                   : 0,
                            valor_pagar_vehiculo        : 0,
                            desgravamen                 : 0,
                            total                       : 0,
                            seleccionar                 : false,

                        });

                        me.arrayPrimaNeta.push({
                            prima_neta: 0
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status == 401) {
                            if (localStorage['authUser']) {
                                this.$router.push({ name: 'login' })
                                location.reload();
                                localStorage.clear();
                            }
                        }
                    })
                }


            });


            me.arraySeguro = [];
            me.selectTipoSeguro('', false, 1)
            me.nombreSeguro = null;
            me.openCargando(true);



        },

        calcularPrimaNeta(c) {
            var total = 0;

            total = this.vaCreCoti.suma_asegurada * c.porcentaje_tasa / 100;

            if (c.auto_auto_aplica) {
                total = total + parseFloat(c.seguro.auto_auto);
            }

            if (c.amparo_patrimonial_aplica) {
                total = total + parseFloat(c.amparo_patrimonial_total);
            }

            if (c.deducible_aplica) {
                total = total + parseFloat(c.deducible_total);
            }
            return total;
        },

        evaluar_des_por(degravamen, porcen) {
            // console.log(degravamen);
            if (degravamen == 0 && porcen == 0) {

                return 0
            } else if (porcen == 0) {
                return 150
            } else if (degravamen == 0) {
                return 0
            } else if (porcen > 0) {
                var total = degravamen * porcen / 100;
                if (total < 104.50) {

                    total = 104.50;
                    return total
                } else {

                    return total
                }

            }
        },

        evaluar_derecho_emicion(primaNeta) {

            var emision = 0;

            if (primaNeta > 0 && primaNeta <= 250) {
                emision = 0.5;
                //primaNeta = primaNeta + emision;
            } else if (primaNeta >= 251 && primaNeta <= 500) {
                emision = 1;
                //primaNeta = primaNeta + emision;
            } else if (primaNeta >= 501 && primaNeta <= 1000) {
                emision = 3;
                //primaNeta = primaNeta + emision;
            } else if (primaNeta >= 1001 && primaNeta <= 2000) {
                emision = 5;
                // primaNeta = primaNeta + emision;
            } else if (primaNeta >= 2001 && primaNeta <= 4000) {
                emision = 7;
                //primaNeta = primaNeta + emision;
            } else if (primaNeta >= 4001 && primaNeta <= 100000) {
                emision = 9;
                //primaNeta = primaNeta + emision;
            }
            return emision
        },

        //Eliminar un seguro que se va a cotizar
        async eliminar_Detalle_seguro(index, id=null) {

            if(this.registrar_actualizar == 2){
              let valor = await this.eliminarDetalle(id);
              if(valor){
                let me = this;
                me.arrayCotizacion.splice(index, 1);
                me.arrayPrimaNeta.splice(index, 1);
              }
            }else{
                let me = this;
                me.arrayCotizacion.splice(index, 1);
                me.arrayPrimaNeta.splice(index, 1);
            }

        },
        //Evitar que se agregue doble vez
        encuentra(id) {
            var sw = 0;
            for (var i = 0; i < this.arrayCotizacion.length; i++) {
                if (this.arrayCotizacion[i].seguro.id == id) {
                    sw = true;
                }
            }
            return sw;
        },
        //Verificar que solo se seleccione un seguro
        verificar_seleccion() {
            var sw = 0;
            for (var i = 0; i < this.arrayCotizacion.length; i++) {

                if (this.arrayCotizacion[i].seleccionar == true) {
                    sw++;
                }
            }
            //console.log(sw);
            return sw;
        },

        vericarPlacaEstado() {
            var sw = 0;
            for (var i = 0; i < this.arrayCotizacion.length; i++) {

                if (this.arrayCotizacion[i].seleccionar == true) {
                    sw++;
                }
            }
            //console.log(sw);
            return sw;
        },

        registrarCotizacion() {

            var me = this;
            var veri = false;
            var url = '/cotizacion/registrar';
            this.openCargando();

            if (me.verificar_seleccion() > 1) {
                me.openCargando(true);

                me.notify(" Seleccione solo un seguro a emitir", "", "top", "right", "fas fa-exclamation-triangle", "danger", ' flipInX', 'flipOutX')
                return
            }

            if(this.compararEstado()){
                me.openCargando(true);

                me.notify(" El estado seleccionado requiere que ingreses una placa", "", "top", "right", "fas fa-exclamation-triangle", "danger", ' flipInX', 'flipOutX')
                return
            }
            //Evaluamos que el estado este en algunos de los mencionados
            //si esta, entonces evaluamos que solo este selecionado un seguro, de lo contrario mandamor error
            switch (me.vaCreCoti.estado) {
                case 'RECOLECION DE DOCUMENTOS':
                    veri = true;
                    break;
                case 'GESTION DE INSPECCION':
                    veri = true;
                    break;

                case 'GESTION DE EMISION':
                    veri = true;
                    break;
                case 'GESTION DE LIBERACION':
                    veri = true;
                    break;
                case 'PRELIQUIDACION':
                    veri = true;
                    break;
                default:
                    veri = false;
                    break;
            }

            if (veri == true) {

                if (me.verificar_seleccion() == 1) {

                } else {
                    me.openCargando(true);
                    me.notify(" Seleccione un seguro a emitir", "", "top", "right", "fas fa-exclamation-triangle", "danger", ' flipInX', 'flipOutX')
                    return
                }
            }


            if (me.arrayCotizacion.length <= 0) {
                me.openCargando(true);
                me.notify(" Agregue almenos un seguro a cotizar", "", "top", "right", "fas fa-exclamation-triangle", "danger", ' flipInX', 'flipOutX')
                return
            }



            axios.post(url, {

                'vaCreCoti': me.vaCreCoti,
                'arrayCotizacion': me.arrayCotizacion,
                'arrayPrimaNeta': me.arrayPrimaNeta
            }).
                then(res => {


                    if (res.data.status) {

                        me.openCargando(true);
                        me.notify(" Cotización registrada con éxito", "", "top", "center", "fas fa-check-circle", "success", ' flipInX', 'flipOutX')
                        me.cleanVariables();
                    } else {

                        me.openCargando(true);

                        if (res.data.code === 501) {
                            me.notify(res.data.mensaje, "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX', 3000)

                        } else {
                            me.notify(" Ha ocurrido un error al registrar la Cotización", "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')
                        }
                        console.error(res.data.mensaje);
                    }

                })
                .catch(error => {
                    me.openCargando(true);//Desactivamos ventana de carga de bloqueo

                    for (var key in error.response.data.errors) {
                        me.notify(" " + error.response.data.errors[key], "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')
                    }
                    if (error.response.status == 401) {
                        if (localStorage['authUser']) {
                            me.$router.push({ name: 'login' })
                            location.reload();
                            localStorage.clear();
                            me.openCargando(true);//Desactivamos ventana de carga de bloqueo
                        }
                    }
                    console.error(error);
                }
                )
        },

        selectCalification(event,cotizacionId) {

            var url = '/cotizacion/calification';
            axios.post(url, {
                'calification': event,
                'id': cotizacionId
            }).then(res => {
                    console.log(res);
                })
                .catch(error => {
                    console.log(error);
            })
        },


        cleanVariables() {
            var me = this;
            me.vaCreCoti = {
                idcliente: 0,
                nombreCliente: '',
                edadCliente: 0,
                suma_asegurada: 0.0,
                idVehiculo: null,
                estado: 0,
                idClasificacion: 0,
                fecha_inicio: null,
                fecha_fin: null,
                modelo_anios_id: 0,
                valor_mercados_id: 0,
                desgravamen: 0.0,
                idTipoUso: 0.0,
                placa: '',
                telefono_s: '',
                comentario: '',
                iduser: 0,
                anio_antiguedad: 0,
                tipo_negocio: 0,
                idmarca: null,
                ramo_id: 1,
                fecha_nacimiento: null,
                categoria_vehiculo : 0,
                anio_vehiculo : 0,
                };
            me.arrayCotizacion = [];
            me.arrayVersiones = [],
                me.arrayVehiculo = [],//vehiculo
                me.idCotizacion = null;
            me.url_pdf = null;
            me.bloquear_seguros = false;
        },

        //Agregar Cliente
        getSelectTipoDoc() {

            var url = '/administracion/usuario/getListarDocumentos';

            axios.get(url)
                .then(res => {

                    var respuesta = res.data;
                    this.aTipoDocumento = respuesta.documento;
                    this.aReferenciasList = respuesta.referencia;
                    this.lista_asesor = respuesta.users;
                    this.aActividadEconomicaList = respuesta.actividadeconomica;
                    this.lista_ramos = respuesta.ramos;
                    //console.log(respuesta.documento);

                })
                .catch(error => {

                    console.error(error);
                    if (error.response.status == 401) {
                        this.$router.push({ name: 'login' })
                        location.reload();
                        localStorage.clear();
                        this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                })
        },

        abrirModalCliente() {
            this.modalShowCliente = !this.modalShowCliente;

            if (this.modalShowCliente == true) {
                //this.getSelectTipoDoc();
                this.tituloModal = "Registrar Cliente";

            } else {
                // this.aTipoDocumento = [];
                this.listHijosConyugue = [];
                this.cleanVariablesCliente();
            }
        },

        abrirModalEmitir() {
            this.modalShowEmitir = !this.modalShowEmitir;

            if (this.modalShowEmitir == true) {
                //this.getSelectTipoDoc();
            } else {
                this.cleanVariablesEmitir();
            }
        },

        cleanVariablesCliente() {
            this.vaCreCliente.cNombre = "";
            this.vaCreCliente.referencia = "";
            this.vaCreCliente.cApellido = 0;
            this.vaCreCliente.fecha_nacimiento = "";
            this.vaCreCliente.eId = "";
            this.vaCreCliente.cNumDoc = "";
            this.vaCreCliente.eIdDocumento = 1;
            this.vaCreCliente.referencia = 1;
            this.vaCreCliente.cDireccion = "";
            this.vaCreCliente.cTelefonoCliente = "";
            this.vaCreCliente.cEmail = "";
            this.vaCreCliente.idactividad_economica = 0;
            this.vaCreCliente.estado_civil = '';
            this.listHijosConyugue = [];
            this.vaCreCliente.hijos_cantidad = 0;
            this.vaCreCliente.nombre_conyugue = '';
            this.vaCreCliente.apellido_conyugue = '';
            this.vaCreCliente.fecha_nacimiento_conyugue = null;
            this.modalShowCliente = false;
        },

        setRegistrarCliente() {

            this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/cliente/registrar';

            axios.post(url, {
                'nombre': this.vaCreCliente.cNombre,
                'referencia': this.vaCreCliente.referencia,
                'apellido': this.vaCreCliente.cApellido,
                'documento': this.vaCreCliente.eIdDocumento,
                'idreferencia': this.vaCreCliente.referencia,
                'numdoc': this.vaCreCliente.cNumDoc,
                'direccion': this.vaCreCliente.cDireccion,
                'telefono': this.vaCreCliente.cTelefonoCliente,
                'fecha_nacimiento': this.vaCreCliente.fecha_nacimiento,
                'email': this.vaCreCliente.cEmail,
                'idactividad_economica': this.vaCreCliente.idactividad_economica,
                'estado_civil': this.vaCreCliente.estado_civil,
                'hijos_cantidad': this.vaCreCliente.hijos_cantidad,
                'nombre_conyugue': this.vaCreCliente.nombre_conyugue,
                'apellido_conyugue': this.vaCreCliente.apellido_conyugue,
                'fecha_nacimiento_conyugue': this.vaCreCliente.fecha_nacimiento_conyugue,
                'arrayHijosConyugue': this.listHijosConyugue
            }).then(res => {

                if (res.data.status) {

                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    this.cleanVariablesCliente();//Limpiamos el form
                    this.selectCliente('', false, 1)
                    this.notify(" Cliente registrado con éxito", "", "top", "center", "fas fa-check-circle", "success", ' flipInX', 'flipOutX')

                } else if (res.data.errorTipo) {
                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    this.notify(" Seleccione almenos un tipo de cliente", "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')
                }

            })
                .catch(error => {
                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo

                    for (var key in error.response.data.errors) {

                        this.notify(" " + error.response.data.errors[key], "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')

                    }
                    if (error.response.status == 401) {
                        this.$router.push({ name: 'login' })
                        location.reload();
                        localStorage.clear();
                        this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                    console.error(error);
                })
        },

        //cerrar modal detalle
        cerrarModalDetalle() {
            this.modalShowDetalleCotizacion = false;
            this.cleanVariables();
        },

        cerrarlModalExport() {
            this.modal_exportar_datos = !this.modal_exportar_datos;
            this.lista_datos_exportar = [
            {
                    'nombre'    : 'Nombre Cliente',
                    'valor'     : 'nombre',
                    'estado'    : false,
                    'columna'   : 'A',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Apellido Cliente',
                    'valor'     : 'apellido',
                    'estado'    : false,
                    'columna'   : 'B',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Tipo Documento',
                    'valor'     : 'tipo_documento',
                    'estado'    : false,
                    'columna'   : 'C',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'N° Documento',
                    'valor'     : 'numero_documento',
                    'estado'    : false,
                    'columna'   : 'D',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'F.Nacimiento',
                    'valor'     : 'fecha_nacimiento',
                    'estado'    : false,
                    'columna'   : 'E',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Dirección',
                    'valor'     : 'direccion',
                    'estado'    : false,
                    'columna'   : 'F',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Email',
                    'valor'     : 'email',
                    'estado'    : false,
                    'columna'   : 'G',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Teléfono',
                    'valor'     : 'telefono',
                    'estado'    : false,
                    'columna'   : 'H',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Teléfono 2 ',
                    'valor'     : 'telefono_2',
                    'estado'    : false,
                    'columna'   : 'I',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Teléfono 3',
                    'valor'     : 'telefono_3',
                    'estado'    : false,
                    'columna'   : 'J',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Referencia',
                    'valor'     : 'referencia',
                    'estado'    : false,
                    'columna'   : 'K',
                    'espacio'   : 20,
                },
                {
                    'nombre'    : 'Tipo Aplacamiento',
                    'valor'     : 'tipo_aplacamiento',
                    'estado'    : false,
                    'columna'   : 'L',
                    'espacio'   : 20,

                },
                {
                    'nombre'    : 'Actividad Económica',
                    'valor'     : 'actividad_economica',
                    'estado'    : false,
                    'columna'   : 'M',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Tipo Cliente',
                    'valor'     : 'tipo_cliente',
                    'estado'    : false,
                    'columna'   : 'N',
                    'espacio'   : 20,
                },
                {
                    'nombre'    : 'Marca',
                    'valor'     : 'marca',
                    'estado'    : false,
                    'columna'   : 'O',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Modelo Vehículo',
                    'valor'     : 'modelo_vehiculo',
                    'estado'    : false,
                    'columna'   : 'P',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Año Vehículo',
                    'valor'     : 'anio_vehiculo',
                    'estado'    : false,
                    'columna'   : 'RQ',
                    'espacio'   : 15,
                },
                {
                    'nombre'    : 'Valor Mercado',
                    'valor'     : 'valor_mercado',
                    'estado'    : false,
                    'columna'   : 'R',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Placa',
                    'valor'     : 'placa',
                    'estado'    : false,
                    'columna'   : 'S',
                    'espacio'   : 20,
                },
                {
                    'nombre'    : 'Estado',
                    'valor'     : 'estado',
                    'estado'    : false,
                    'columna'   : 'T',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Clasificación',
                    'valor'     : 'clasificacion',
                    'estado'    : false,
                    'columna'   : 'U',
                    'espacio'   : 25,
                },
                {
                    'nombre'    : 'Tipo Uso',
                    'valor'     : 'tipo_uso',
                    'estado'    : false,
                    'columna'   : 'V',
                    'espacio'   : 25,
                },
                {
                    'nombre'    : 'Tipo Negocio',
                    'valor'     : 'tipo_negocio',
                    'estado'    : false,
                    'columna'   : 'W',
                    'espacio'   : 25,
                },
                {
                    'nombre'    : 'Seguro',
                    'valor'     : 'seguro',
                    'estado'    : false,
                    'columna'   : 'X',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : 'Ramo',
                    'valor'     : 'ramo',
                    'estado'    : false,
                    'columna'   : 'Y',
                    'espacio'   : 30,
                },
                {
                    'nombre'    : '% Tasa',
                    'valor'     : 'tasa',
                    'estado'    : false,
                    'columna'   : 'Z',
                    'espacio'   : 10,
                },
                {
                    'nombre'    : 'Aplica Auto x Auto',
                    'valor'     : 'aplica_auto_x_auto',
                    'estado'    : false,
                    'columna'   : 'AA',
                    'espacio'   : 10,
                },
                {
                    'nombre'    : 'Aplica Cero Deducible',
                    'valor'     : 'aplica_cero_deducible',
                    'estado'    : false,
                    'columna'   : 'AB',
                    'espacio'   : 10,
                },
                {
                    'nombre'    : 'Aplica Amparo Patrimonial',
                    'valor'     : 'aplica_amparo_patrimonial',
                    'estado'    : false,
                    'columna'   : 'AC',
                    'espacio'   : 10,
                },
                {
                    'nombre'    : 'Aplica Dispositivo de rastreo',
                    'valor'     : 'aplica_dispositivo_rastreo',
                    'estado'    : false,
                    'columna'   : 'AD',
                    'espacio'   : 10,
                },
            ]
            this.filtro_mes_anio_export = null
        },

        cerrarModalSeguimiento() {

            this.modalShowSeguimiento = false;
            this.seguimiento.id = 0;
            this.cleanSeguimiento();
            this.arraySeguimiento = [];
        },
        //Detalle modal
        abrirModalDetalleCotizacion(id) {
            let me = this;
            var url = '/cotizacion/viewdetalle';

            me.openCargando();

            //me.url_pdf = '/cotizacion/generarPDFCotizacion/'+id,'_blank';


            axios.post(url, { 'id': id })
                .then(res => {

                    var respuesta = res.data;
                    me.arrayDetalleCotizacion = respuesta.cotizacion
                    me.openCargando(true);
                    me.modalShowDetalleCotizacion = !me.modalShowDetalleCotizacion;

                    var config = {
                        responseType: "blob",
                    };
                    var url = "/cotizacion/setGenerarDocumento";
                    axios
                        .post(url, { id: id }, config)
                        .then((response) => {
                            this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                            var oMyBlob = new Blob([response.data], { type: "application/pdf" }); // the blob
                            me.url_pdf = URL.createObjectURL(oMyBlob);
                            //window.open(url

                        })
                        .catch((error) => {
                            console.log(error);
                        });

                })
                .catch(error => {
                    console.error(error);
                    me.openCargando(true);
                    if (error.response.status == 401) {
                        //this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();

                    }
                })
        },

        cargarPdf(id) {
            // window.open('/cotizacion/generarPDFCotizacion/'+id,'_blank');
            var config = {
                responseType: "blob",
            };
            this.openCargando();//Activamos pantalla de carga de bloqueo
            var url = "/cotizacion/setGenerarDocumento";
            axios
                .post(url, { id: id }, config)
                .then((response) => {
                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    this.listIdPDF = [];
                    var oMyBlob = new Blob([response.data], { type: "application/pdf" }); // the blob
                    var url = URL.createObjectURL(oMyBlob);
                    window.open(url);


                })
                .catch((error) => {
                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    if (error.response.status == 401) {
                        this.$router.push({ name: "login" });
                        location.reload();
                        localStorage.clear();
                        this.openCargando(true);//Desactivamos ventana de carga de bloqueo

                    }
                });
        },

        cargarEditarCotizacion(id) {

            let me = this;
            me.openCargando();
            var url = '/cotizacion/editardetalle';
            // me.getSelectTipoUso();
            me.idCotizacion = id;

            axios.post(url, { 'id': id })
                .then(res => {

                    var respuesta = res.data;

                    me.arrayVehiculo        = respuesta.modelo;
                    me.arrayCliente         = respuesta.cliente;
                    me.arrayClasificacion   = respuesta.clasificacion;
                    me.arrayTipoUso = respuesta.tipo_uso;

                    me.vaCreCoti.idcliente = respuesta.cotizacion['idcliente'];
                    me.arrayCliente.forEach(e => {
                        if (respuesta.cotizacion['idcliente'] == e.id) {
                            me.vaCreCoti.idcliente = e.id;
                            me.vaCreCoti.nombreCliente = e.nombre;
                            me.vaCreCoti.edadCliente = e.edad;
                            me.vaCreCoti.fecha_nacimiento = e.fecha_nacimiento;
                        }
                    });

                    me.vaCreCoti.suma_asegurada = respuesta.cotizacion['suma_asegurada'],

                        me.arrayVehiculo.forEach(e => {
                            if (respuesta.cotizacion['idmodelo'] == e.id) {
                                me.vaCreCoti.idVehiculo = e.id;
                                me.vaCreCoti.nombreVehiculo = e.nombre;
                            }
                        });

                    me.vaCreCoti.estado = respuesta.cotizacion['estado'];
                    me.vaCreCoti.ramo_id = respuesta.cotizacion['ramo_seguro_id'];
                    me.vaCreCoti.tipo_negocio = respuesta.cotizacion['tipo_negocio'];
                    me.vaCreCoti.idClasificacion = respuesta.cotizacion['idclasificacion'];
                    me.vaCreCoti.fecha_inicio = respuesta.cotizacion['vigencia_inicio'];
                    me.vaCreCoti.fecha_fin = respuesta.cotizacion['vigencia_fin'];
                    me.vaCreCoti.desgravamen = respuesta.cotizacion['desgravamen'];
                    me.vaCreCoti.idTipoUso = respuesta.cotizacion['idtipo_uso'];
                    me.vaCreCoti.placa = respuesta.cotizacion['placa'];
                    me.vaCreCoti.anio_antiguedad = respuesta.cotizacion['anio_antiguedad'];
                    me.vaCreCoti.telefono_s = respuesta.cotizacion['telefono'];
                    me.vaCreCoti.comentario = respuesta.cotizacion['comentario']; //iduser
                    me.vaCreCoti.iduser = respuesta.cotizacion['iduser'];


                    me.selectsGroup();
                    me.vaCreCoti.idmarca = respuesta.cotizacion['idmarca'];
                    me.selectVehiculos(me.vaCreCoti.idmarca);
                    me.vaCreCoti.idVehiculo = respuesta.cotizacion['idmodelo'];
                    //me.selectVersiones(me.vaCreCoti.idVehiculo);

                    me.vaCreCoti.modelo_anios_id = respuesta.cotizacion['modelo_anios_id'];
                    me.vaCreCoti.valor_mercados_id = respuesta.cotizacion['valor_mercados_id'];

                    respuesta.detalle.forEach(e => {
                        me.arrayCotizacion.push({
                            seguro: e.seguro[0],
                            dis_rastreo_aplica: ((e.cotizacion_seguro_detalle.dis_rastreo_aplica == 1) ? true : false),
                            deducible: e.deducible,
                            covertura: e.covertura,
                            porcentaje_tasa: e.porcentaje_tasa,
                            //id_Tasa: e.tasa.id,
                            auto_auto_aplica: ((e.cotizacion_seguro_detalle.auto_auto_aplica == 1) ? true : false),
                            deducible_aplica: ((e.cotizacion_seguro_detalle.deducible_aplica == 1) ? true : false),
                            amparo_patrimonial_aplica: ((e.cotizacion_seguro_detalle.amparo_patrimonial_aplica == 1) ? true : false),
                            interes_financiamiento_por: e.cotizacion_seguro_detalle.interes_financiamiento_por,
                            interes_financiamiento: 0,
                            derecho_emicion: 0,
                            s_bancos_por: e.cotizacion_seguro_detalle.s_bancos_por,
                            s_bancos: 0,
                            s_campesino_por: e.cotizacion_seguro_detalle.s_campesino_por,
                            s_campesino: 0,
                            iva_por: e.cotizacion_seguro_detalle.iva_por,
                            iva_total: 0,
                            valor_pagar_vehiculo: 0,
                            desgravamen: 0,
                            total: 0,
                            seleccionar: ((e.cotizacion_seguro_detalle.seleccionar == 'SI') ? true : false),
                            id_cotizacion_seguro: e.id_cotizacion_seguro

                        });

                        me.arrayPrimaNeta.push({
                            prima_neta: 0
                        });

                        if (e.cotizacion_seguro_detalle.seleccionar == 'SI') {
                            me.bloquear_seguros = true;
                        }

                    });
                    me.agregar = false;
                    me.registrar_actualizar = 2
                    me.openCargando(true);

                })
                .catch(error => {
                    this.cleanVariables();
                    console.log(error);
                    if (error.response.status == 401) {
                        if (localStorage['authUser']) {
                            this.$router.push({ name: 'login' })
                            location.reload();
                            localStorage.clear();
                        }
                    }
                })

        },

        cargarDatosCotizacion(id) {

            let me = this;
            me.openCargando();
            var url = '/cotizacion/editardetalle';


            axios.post(url, { 'id': id })
                .then(res => {

                    var respuesta = res.data;

                    me.arrayVehiculo        = respuesta.modelo;
                    me.arrayCliente         = respuesta.cliente;
                    me.arrayClasificacion   = respuesta.clasificacion;
                    me.arrayTipoUso = respuesta.tipo_uso;

                    me.vaCreCoti.idcliente = respuesta.cotizacion['idcliente'];
                    me.arrayCliente.forEach(e => {
                        if (respuesta.cotizacion['idcliente'] == e.id) {
                            me.vaCreCoti.idcliente = e.id;
                            me.vaCreCoti.nombreCliente = e.nombre;
                            me.vaCreCoti.edadCliente = e.edad;
                            me.vaCreCoti.fecha_nacimiento = e.fecha_nacimiento;
                        }
                    });

                    me.vaCreCoti.suma_asegurada = respuesta.cotizacion['suma_asegurada'],

                        me.arrayVehiculo.forEach(e => {
                            if (respuesta.cotizacion['idmodelo'] == e.id) {
                                me.vaCreCoti.idVehiculo = e.id;
                                me.vaCreCoti.nombreVehiculo = e.nombre;
                            }
                        });

                    me.vaCreCoti.estado = respuesta.cotizacion['estado'];
                    me.vaCreCoti.ramo_id = respuesta.cotizacion['ramo_seguro_id'];
                    me.vaCreCoti.tipo_negocio = 2;
                    me.vaCreCoti.idClasificacion = respuesta.cotizacion['idclasificacion'];
                    me.vaCreCoti.fecha_inicio = respuesta.cotizacion['vigencia_inicio'];
                    me.vaCreCoti.fecha_fin = respuesta.cotizacion['vigencia_fin'];
                    me.vaCreCoti.desgravamen = respuesta.cotizacion['desgravamen'];
                    me.vaCreCoti.idTipoUso = respuesta.cotizacion['idtipo_uso'];
                    me.vaCreCoti.placa = respuesta.cotizacion['placa'];
                    me.vaCreCoti.anio_antiguedad = respuesta.cotizacion['anio_antiguedad'];
                    me.vaCreCoti.telefono_s = respuesta.cotizacion['telefono'];
                    me.vaCreCoti.comentario = respuesta.cotizacion['comentario']; //iduser
                    me.vaCreCoti.iduser = respuesta.cotizacion['iduser'];


                    me.selectsGroup();
                    me.vaCreCoti.idmarca = respuesta.cotizacion['idmarca'];
                    me.selectVehiculos(me.vaCreCoti.idmarca);
                    me.vaCreCoti.idVehiculo = respuesta.cotizacion['idmodelo'];
                    //me.selectVersiones(me.vaCreCoti.idVehiculo);

                    me.vaCreCoti.modelo_anios_id = respuesta.cotizacion['modelo_anios_id'];
                    me.vaCreCoti.valor_mercados_id = respuesta.cotizacion['valor_mercados_id'];

                    respuesta.detalle.forEach(e => {
                        me.arrayCotizacion.push({
                            seguro: e.seguro[0],
                            dis_rastreo_aplica: ((e.cotizacion_seguro_detalle.dis_rastreo_aplica == 1) ? true : false),
                            deducible: e.deducible,
                            covertura: e.covertura,
                            porcentaje_tasa: e.porcentaje_tasa,
                            //id_Tasa: e.tasa.id,
                            auto_auto_aplica: ((e.cotizacion_seguro_detalle.auto_auto_aplica == 1) ? true : false),
                            deducible_aplica: ((e.cotizacion_seguro_detalle.deducible_aplica == 1) ? true : false),
                            amparo_patrimonial_aplica: ((e.cotizacion_seguro_detalle.amparo_patrimonial_aplica == 1) ? true : false),
                            interes_financiamiento_por: e.cotizacion_seguro_detalle.interes_financiamiento_por,
                            interes_financiamiento: 0,
                            derecho_emicion: 0,
                            s_bancos_por: e.cotizacion_seguro_detalle.s_bancos_por,
                            s_bancos: 0,
                            s_campesino_por: e.cotizacion_seguro_detalle.s_campesino_por,
                            s_campesino: 0,
                            iva_por: e.cotizacion_seguro_detalle.iva_por,
                            iva_total: 0,
                            valor_pagar_vehiculo: 0,
                            desgravamen: 0,
                            total: 0,
                            seleccionar: ((e.cotizacion_seguro_detalle.seleccionar == 'SI') ? true : false),
                            id_cotizacion_seguro: e.id_cotizacion_seguro

                        });

                        me.arrayPrimaNeta.push({
                            prima_neta: 0
                        });

                        if (e.cotizacion_seguro_detalle.seleccionar == 'SI') {
                            me.bloquear_seguros = true;
                        }

                    });
                    me.agregar = false;
                    me.registrar_actualizar = 1
                    me.openCargando(true);
                })
                .catch(error => {
                    this.cleanVariables();
                    console.error(error);
                    if (error.response.status == 401) {
                        if (localStorage['authUser']) {
                            this.$router.push({ name: 'login' })
                            location.reload();
                            localStorage.clear();
                        }
                    }
                })

        },

        actualizarCotizacion() {

            var me = this;
            var veri = false;
            var url = '/cotizacion/actualizar';
            this.openCargando();

            if (me.verificar_seleccion() > 1) {
                me.openCargando(true);

                me.notify(" Seleccione solo un seguro a emitir", "", "top", "right", "fas fa-exclamation-triangle", "danger", ' flipInX', 'flipOutX')
                return
            }

            if(me.compararEstado()){
                me.openCargando(true);

                me.notify(" El estado seleccionado requiere que ingreses una placa", "", "top", "right", "fas fa-exclamation-triangle", "danger", ' flipInX', 'flipOutX')
                return
            }
            //Evaluamos que el estado este en algunos de los mencionados
            //si esta, entonces evaluamos que solo este selecionado un seguro, de lo contrario mandamor error
            switch (me.vaCreCoti.estado) {
                case 'RECOLECION DE DOCUMENTOS':
                    veri = true;
                    break;
                case 'GESTION DE INSPECCION':
                    veri = true;
                    break;

                case 'GESTION DE EMISION':
                    veri = true;
                    break;
                case 'GESTION DE LIBERACION':
                    veri = true;
                    break;
                case 'PRELIQUIDACION':
                    veri = true;
                    break;
                default:
                    veri = false;
                    break;
            }

            if (veri == true) {

                if (me.verificar_seleccion() == 1) {

                } else {
                    me.openCargando(true);
                    me.notify(" Seleccione un seguro a emitir", "", "top", "right", "fas fa-exclamation-triangle", "danger", ' flipInX', 'flipOutX')
                    return
                }
            }


            if (me.arrayCotizacion.length <= 0) {
                me.openCargando(true);
                me.notify(" Agregue almenos un seguro a cotizar", "", "top", "right", "fas fa-exclamation-triangle", "danger", ' flipInX', 'flipOutX')
                return
            }



            axios.post(url, {

                'vaCreCoti': me.vaCreCoti,
                'arrayCotizacion': me.arrayCotizacion,
                'arrayPrimaNeta': me.arrayPrimaNeta,
                'id': me.idCotizacion
            }).then(res => {


                    if (res.data.status) {

                        me.openCargando(true);
                        me.notify(" Cotización actualizada con éxito", "", "top", "center", "fas fa-check-circle", "success", ' flipInX', 'flipOutX')
                        me.cleanVariables();
                        me.agregarCoti();
                    } else {
                        me.openCargando(true);
                        me.notify(" Ha ocurrido un error al actualizar la Cotización", "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')
                        console.error(res.data.mensaje);
                    }

                })
            .catch(error => {
                    me.openCargando(true);//Desactivamos ventana de carga de bloqueo

                    for (var key in error.response.data.errors) {
                        me.notify(" " + error.response.data.errors[key], "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')
                    }
                    if (error.response.status == 401) {
                        if (localStorage['authUser']) {
                            me.$router.push({ name: 'login' })
                            location.reload();
                            localStorage.clear();
                            me.openCargando(true);//Desactivamos ventana de carga de bloqueo
                        }
                    }
                    console.error(error);
                }
                )
        },

        seguimientoDetalle(id) {
            let me = this;
            var url = '/cotizacion/seguimiento';
            me.openCargando();
            this.evidencias();
            axios.post(url, { 'id': id })
                .then(res => {

                    var respuesta = res.data;

                    me.arraySeguimiento = respuesta.seguimiento;
                    me.cotizacion = respuesta.detalle;
                    me.seguimiento.id = id;
                    me.modalShowSeguimiento = true;
                    me.openCargando(true);


                })
                .catch(error => {
                    me.openCargando(true);
                    console.error(error);
                    if (error.response.status == 401) {
                        if (localStorage['authUser']) {
                            me.$router.push({ name: 'login' })
                            location.reload();
                            localStorage.clear();
                            me.openCargando(true);//Desactivamos ventana de carga de bloqueo
                        }
                    }
                })
        },

        obtenerfile(e) {
            let file = e.target.files[0]
            this.seguimiento.file = file
        },

        setRegistrarSeguimiento() {

            //this.openCargando();//Activamos ventana de carga de bloqueo
            let me = this;
            var url = '/seguimiento/registrar';
            me.openCargando();

            me.form.append('id', me.seguimiento.id);
            me.form.append('estado', me.seguimiento.estado);
            me.form.append('fecha_inicio', me.seguimiento.fecha_inicio);
            me.form.append('fecha_fin', me.seguimiento.fecha_fin);
            me.form.append('comentario', me.seguimiento.comentario);
            me.form.append('file', me.seguimiento.file);

            const config = { headers: { 'Content-Type': 'multipart/form-data' } }

            axios.post(url, me.form, config).then(res => {
                me.openCargando(true);

                if (res.data.status) {

                    this.notify(" Registro exitoso", "", "top", "center", "fas fa-check-circle", "success", ' flipInX', 'flipOutX')
                    me.cleanSeguimiento();
                    me.getListCotizaciones(this.pagination.current_page, this.pag_mostrar);;
                    me.seguimientoDetalle(me.seguimiento.id);//IdCotizacion

                }

            })
                .catch(error => {
                    me.openCargando(true);//Desactivamos ventana de carga de bloqueo

                    for (var key in error.response.data.errors) {

                        me.notify(" " + error.response.data.errors[key], "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')
                        //console.error(error);
                    }
                    if (error.response.status == 401) {
                        me.$router.push({ name: 'login' })
                        location.reload();
                        localStorage.clear();
                        me.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                    console.error(error);

                })
        },

        cleanSeguimiento() {
            //this.seguimiento.id= 0;
            this.seguimiento.estado = 0;
            this.seguimiento.fecha_inicio = '';
            this.seguimiento.fecha_fin = '';
            this.seguimiento.comentario = '';
            this.seguimiento.file = '';
            this.form = new FormData;
            //$('#img_file').fileinput('reset');
            $('#img_file').fileinput('clear');
        },

        getDataUser() {
            let me = this;
            var url = "/dashboard/user";

            axios
                .post(url)
                .then((res) => {
                    me.usuario = res.data.user_by;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        eliminarCotizacion(id) {
            let me = this;

            me.swalWithBootstrapButtons.fire({
                title: '¿Está seguro de eliminar la cotización?',
                //text: "You won't be able to revert this!",
                icon: 'error',
                showCancelButton: true,
                confirmButtonText: 'Si, eliminar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true
            }).then((result) => {

                if (result.value) {

                    var url = '/cotizacion/eliminar';
                    me.openCargando();

                    axios.post(url, {
                        'id': id,
                    })
                        .then(res => {

                            me.openCargando(true);
                            me.getListCotizaciones(this.pagination.current_page, this.pag_mostrar);;

                            if (res.data.status) {

                                me.notify(" Cotización eliminada con éxito", "", "top", "center", "fas fa-user-check", "success", ' flipInX', 'flipOutX')
                            } else {
                                me.notify(" Error al eliminar la cotización", "", "top", "center", "fas fa-user-check", "danger", ' flipInX', 'flipOutX')
                            }

                        })
                        .catch(error => {
                            this.openCargando(true);
                            if (error.response.status == 401) {
                                this.$router.push({ name: 'login' })
                                location.reload();
                                localStorage.clear();
                                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                            }
                            console.error(error);
                        })
                }
            }
            )
        },

       async eliminarDetalle(id) {

            let me = this;

            const { value: message } = await me.swalWithBootstrapButtons.fire({
                title: '¿Está seguro de eliminar el detalle de la aseguradora?',
                text: "Ten en cuenta que al eliminar este registro, se eliminará de forma permanente de la base de datos y no será posible recuperarlo posteriormente.",
                icon: 'error',
                showCancelButton: true,
                confirmButtonText: 'Si, eliminar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true
            });


            if (message) {
                Swal.showLoading();

                var url = '/cotizacion/eliminar-detalle-aseguradora';

                    axios.post(url, {
                        'id': id,
                    })
                        .then(res => {

                            me.notify(" Detalle eliminado con éxito", "", "top", "center", "fas fa-user-check", "success", ' flipInX', 'flipOutX')
                        })
                        .catch(error => {

                            if (error.response.status == 401) {
                                this.$router.push({ name: 'login' })
                                location.reload();
                                localStorage.clear();
                                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                            }
                            console.error(error);
                        })

            }

            return message;

        },

        enviar_correo(id) {
            let me = this;
            var url = '/cotizacion/enviocorreo';
            me.openCargando();
            axios.post(url, { 'id': id, })
                .then(res => {
                    me.openCargando(true);
                    if (res.data.status) {

                        me.notify(" Correo enviando con éxito", "", "top", "center", "fas fa-user-check", "success", ' flipInX', 'flipOutX')
                    } else {
                        me.notify(" Error al enviar el correo", "", "top", "center", "fas fa-user-check", "danger", ' flipInX', 'flipOutX')
                    }
                })
                .catch(error => {
                    me.openCargando(true);
                    if (error.response.status == 401) {
                        this.$router.push({ name: 'login' })
                        location.reload();
                        localStorage.clear();
                        this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                    console.error(error);
                })
        },

        enviar_correo_emitir(id) {
            let me = this;
            var url = '/cotizacion/enviocorreo-emitir';
            me.openCargando();
            axios.post(url, { 'id': id, })
                .then(res => {
                    me.openCargando(true);
                    if (res.data.status) {

                        me.notify(" Correo enviando con éxito", "", "top", "center", "fas fa-user-check", "success", ' flipInX', 'flipOutX')
                    } else {
                        me.notify(" Error al enviar el correo", "", "top", "center", "fas fa-user-check", "danger", ' flipInX', 'flipOutX')
                    }
                })
                .catch(error => {
                    me.openCargando(true);
                    if (error.response.status == 401) {
                        this.$router.push({ name: 'login' })
                        location.reload();
                        localStorage.clear();
                        this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                    console.error(error);
                })
        },

        evidencias() {
            this.$nextTick(() => {

                $('#img_file').fileinput({
                    language: 'es',
                    allowedFileExtensions: ['jpeg', 'jpg', 'png', 'doc', 'docx', 'txt', 'xls', 'pdf', 'xlsx'],
                    maxFileSize: 30000,//8mb
                    showUpload: false,
                    showClose: false,
                    dropZoneEnabled: true,
                    browseLabel: '',
                    removeLabel: '',
                    browseIcon: '<i class="fas fa-folder-open"></i>',
                    removeIcon: '<i class="fas fa-trash-alt"></i>',
                    overwriteInitial: true, showCaption: false,

                    theme: "fas",
                    preferIconicPreview: true,
                    previewFileIconSettings: { // configure your icon file extensions
                        'doc': '<i class="fas fa-file-word text-primary"></i>',
                        'xls': '<i class="fas fa-file-excel text-success"></i>',
                        'ppt': '<i class="fas fa-file-powerpoint text-danger"></i>',
                        'pdf': '<i class="fas fa-file-pdf text-danger"></i>',
                        'zip': '<i class="fas fa-file-archive text-muted"></i>',
                        'htm': '<i class="fas fa-file-code text-info"></i>',
                        'txt': '<i class="fas fa-file-alt text-info"></i>',
                        'mov': '<i class="fas fa-file-video text-warning"></i>',
                        'mp3': '<i class="fas fa-file-audio text-warning"></i>',
                        // note for these file types below no extension determination logic
                        // has been configured (the keys itself will be used as extensions)
                        'jpg': '<i class="fas fa-file-image text-danger"></i>',
                        'gif': '<i class="fas fa-file-image text-muted"></i>',
                        'png': '<i class="fas fa-file-image text-primary"></i>'
                    },
                    previewFileExtSettings: { // configure the logic for determining icon file extensions
                        'doc': function (ext) {
                            return ext.match(/(doc|docx)$/i);
                        },
                        'xls': function (ext) {
                            return ext.match(/(xls|xlsx)$/i);
                        },
                        'ppt': function (ext) {
                            return ext.match(/(ppt|pptx)$/i);
                        },
                        'zip': function (ext) {
                            return ext.match(/(zip|rar|tar|gzip|gz|7z)$/i);
                        },
                        'htm': function (ext) {
                            return ext.match(/(htm|html)$/i);
                        },
                        'txt': function (ext) {
                            return ext.match(/(txt|ini|csv|java|php|js|css)$/i);
                        },
                        'mov': function (ext) {
                            return ext.match(/(avi|mpg|mkv|mov|mp4|3gp|webm|wmv)$/i);
                        },
                        'mp3': function (ext) {
                            return ext.match(/(mp3|wav)$/i);
                        }
                    }
                });

            });
        },

        calcular_tasas(edad_v, antiguedad_v, valor_asegurado_v) {
            let edad = edad_v
            let antiguedad = antiguedad_v
            let valor_asegurado = valor_asegurado_v

            if (edad >= 18 && edad <= 25 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.70
            if (edad >= 18 && edad <= 25 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 40000 && valor_asegurado <= 69999) return 2.80
            if (edad >= 18 && edad <= 25 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 30000 && valor_asegurado <= 39999) return 2.90
            if (edad >= 18 && edad <= 25 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 20000 && valor_asegurado <= 29999) return 3.00
            if (edad >= 18 && edad <= 25 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 0 && valor_asegurado <= 19999) return 3.10

            if (edad >= 18 && edad <= 25 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.30
            if (edad >= 18 && edad <= 25 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 40000 && valor_asegurado <= 69999) return 3.35
            if (edad >= 18 && edad <= 25 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 30000 && valor_asegurado <= 39999) return 3.40
            if (edad >= 18 && edad <= 25 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 20000 && valor_asegurado <= 29999) return 3.45
            if (edad >= 18 && edad <= 25 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 0 && valor_asegurado <= 19999) return 3.50

            if (edad >= 18 && edad <= 25 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.30
            if (edad >= 18 && edad <= 25 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 40000 && valor_asegurado <= 69999) return 3.40
            if (edad >= 18 && edad <= 25 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 30000 && valor_asegurado <= 39999) return 3.45
            if (edad >= 18 && edad <= 25 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 20000 && valor_asegurado <= 29999) return 3.50
            if (edad >= 18 && edad <= 25 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 0 && valor_asegurado <= 19999) return 3.60

            if (edad >= 18 && edad <= 25 && antiguedad >= 11 && antiguedad <= 15 && valor_asegurado >= 30000 && valor_asegurado <= 100000) return 4.30

            if (edad >= 18 && edad <= 25 && antiguedad >= 11 && antiguedad <= 15 && valor_asegurado >= 0 && valor_asegurado <= 29999) return 5.00

            if (edad >= 26 && edad <= 32 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.60
            if (edad >= 26 && edad <= 32 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 40000 && valor_asegurado <= 69999) return 2.70
            if (edad >= 26 && edad <= 32 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 30000 && valor_asegurado <= 39999) return 2.80
            if (edad >= 26 && edad <= 32 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 20000 && valor_asegurado <= 29999) return 2.90
            if (edad >= 26 && edad <= 32 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 0 && valor_asegurado <= 19999) return 3.00

            if (edad >= 26 && edad <= 32 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.25
            if (edad >= 26 && edad <= 32 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 40000 && valor_asegurado <= 69999) return 3.30
            if (edad >= 26 && edad <= 32 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 30000 && valor_asegurado <= 39999) return 3.35
            if (edad >= 26 && edad <= 32 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 20000 && valor_asegurado <= 29999) return 3.40
            if (edad >= 26 && edad <= 32 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 0 && valor_asegurado <= 19999) return 3.45

            if (edad >= 26 && edad <= 32 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.30
            if (edad >= 26 && edad <= 32 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 40000 && valor_asegurado <= 69999) return 3.35
            if (edad >= 26 && edad <= 32 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 30000 && valor_asegurado <= 39999) return 3.40
            if (edad >= 26 && edad <= 32 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 20000 && valor_asegurado <= 29999) return 3.45
            if (edad >= 26 && edad <= 32 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 0 && valor_asegurado <= 19999) return 3.50

            if (edad >= 26 && edad <= 32 && antiguedad >= 11 && antiguedad <= 15 && valor_asegurado >= 30000 && valor_asegurado <= 100000) return 4.20

            if (edad >= 26 && edad <= 32 && antiguedad >= 11 && antiguedad <= 15 && valor_asegurado >= 0 && valor_asegurado <= 29000) return 4.80

            if (edad >= 33 && edad <= 40 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.50
            if (edad >= 33 && edad <= 40 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 40000 && valor_asegurado <= 69999) return 2.60
            if (edad >= 33 && edad <= 40 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 30000 && valor_asegurado <= 39999) return 2.70
            if (edad >= 33 && edad <= 40 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 20000 && valor_asegurado <= 29999) return 2.80
            if (edad >= 33 && edad <= 40 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 0 && valor_asegurado <= 19999) return 2.90

            if (edad >= 33 && edad <= 40 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.20
            if (edad >= 33 && edad <= 40 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 40000 && valor_asegurado <= 69999) return 3.25
            if (edad >= 33 && edad <= 40 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 30000 && valor_asegurado <= 39999) return 3.30
            if (edad >= 33 && edad <= 40 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 20000 && valor_asegurado <= 29999) return 3.35
            if (edad >= 33 && edad <= 40 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 0 && valor_asegurado <= 19999) return 3.40

            if (edad >= 33 && edad <= 40 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.25
            if (edad >= 33 && edad <= 40 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 40000 && valor_asegurado <= 69999) return 3.30
            if (edad >= 33 && edad <= 40 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 30000 && valor_asegurado <= 39999) return 3.35
            if (edad >= 33 && edad <= 40 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 20000 && valor_asegurado <= 29999) return 3.40
            if (edad >= 33 && edad <= 40 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 0 && valor_asegurado <= 19999) return 3.45

            if (edad >= 33 && edad <= 40 && antiguedad >= 11 && antiguedad <= 15 && valor_asegurado >= 30000 && valor_asegurado <= 100000) return 4.10

            if (edad >= 33 && edad <= 40 && antiguedad >= 11 && antiguedad <= 15 && valor_asegurado >= 0 && valor_asegurado <= 29000) return 4.70

            if (edad >= 41 && edad <= 75 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.40
            if (edad >= 41 && edad <= 75 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 40000 && valor_asegurado <= 69999) return 2.50
            if (edad >= 41 && edad <= 75 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 30000 && valor_asegurado <= 39999) return 2.60
            if (edad >= 41 && edad <= 75 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 20000 && valor_asegurado <= 29999) return 2.70
            if (edad >= 41 && edad <= 75 && antiguedad >= 0 && antiguedad <= 3 && valor_asegurado >= 0 && valor_asegurado <= 19999) return 2.80

            if (edad >= 41 && edad <= 75 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.10
            if (edad >= 41 && edad <= 75 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 40000 && valor_asegurado <= 69999) return 3.20
            if (edad >= 41 && edad <= 75 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 30000 && valor_asegurado <= 39999) return 3.25
            if (edad >= 41 && edad <= 75 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 20000 && valor_asegurado <= 29999) return 3.30
            if (edad >= 41 && edad <= 75 && antiguedad >= 4 && antiguedad <= 6 && valor_asegurado >= 0 && valor_asegurado <= 19999) return 3.35

            if (edad >= 41 && edad <= 75 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.20
            if (edad >= 41 && edad <= 75 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 40000 && valor_asegurado <= 69999) return 2.25
            if (edad >= 41 && edad <= 75 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 30000 && valor_asegurado <= 39999) return 3.00
            if (edad >= 41 && edad <= 75 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 20000 && valor_asegurado <= 29999) return 3.35
            if (edad >= 41 && edad <= 75 && antiguedad >= 7 && antiguedad <= 10 && valor_asegurado >= 0 && valor_asegurado <= 19999) return 3.40

            if (edad >= 41 && edad <= 75 && antiguedad >= 11 && antiguedad <= 15 && valor_asegurado >= 30000 && valor_asegurado <= 100000) return 4.00

            if (edad >= 41 && edad <= 75 && antiguedad >= 11 && antiguedad <= 15 && valor_asegurado >= 0 && valor_asegurado <= 29000) return 4.50
            return 0

        },

        enviarWsp(numero, nombre) {

            var url = 'https://api.whatsapp.com/send?phone=';

            if (numero === '' && numero === null) {
                this.notify("El usuario no cuenta con un número de celular", "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')
            } else {

                if (numero.startsWith('+593')) {
                    url = url + numero + '&text=Estimando(a)%20Sr.%20' + nombre + '%20Adjunto%20en%20archivo%20PDF%20encontrará%20nuestra%20mejor%20cotización%20para%20su%20seguro%20vehicular,%20al%20amparo%20de%20nuestro%20Plan%20de%20Seguro%20Corporativo%20de%20Vehículos,%20negociado%20especialmente%20para%20nuestros%20clientes.';
                } else {
                    url = url + '+593' + numero + '&text=Estimando(a)%20Sr.%20' + nombre + '%20Adjunto%20en%20archivo%20PDF%20encontrará%20nuestra%20mejor%20cotización%20para%20su%20seguro%20vehicular,%20al%20amparo%20de%20nuestro%20Plan%20de%20Seguro%20Corporativo%20de%20Vehículos,%20negociado%20especialmente%20para%20nuestros%20clientes.';
                }
                window.open(url);

            }
        },

        obtenerEmitirCotizacion(id) {
            let me = this;
            me.openCargando();
            var url = '/cotizacion/obtenerdataemitir';
            axios.get(url, {
                params: {
                    id: id
                }
            })
                .then(res => {
                    var respuesta = res.data;
                    /*  /*Asegurado */
                    me.emitir.id_cliente = respuesta.id_cliente;
                    me.emitir.asegurado_nombre = respuesta.asegurado_nombre;
                    me.emitir.asegurado_cedula = respuesta.asegurado_cedula;
                    me.emitir.asegurado_telefono = respuesta.asegurado_telefono;
                    me.emitir.asegurado_correo = respuesta.asegurado_correo;
                    me.emitir.asegurado_direccion = respuesta.asegurado_direccion;
                    /*Beneficiario */
                    me.emitir.beneficiario_id = respuesta.beneficiario_id;
                    me.emitir.beneficiario_nombre = respuesta.beneficiario_nombre;
                    me.emitir.beneficiario_cedula = respuesta.beneficiario_cedula;
                    me.emitir.beneficiario_telefono = respuesta.beneficiario_telefono;
                    me.emitir.beneficiario_correo = respuesta.beneficiario_correo;
                    me.emitir.beneficiario_direccion = respuesta.beneficiario_direccion;
                    /*Solicitante */
                    me.emitir.solicitante_id = respuesta.solicitante_id;
                    me.emitir.solicitante_nombre = respuesta.solicitante_nombre;
                    me.emitir.solicitante_cedula = respuesta.solicitante_cedula;
                    me.emitir.solicitante_telefono = respuesta.solicitante_telefono;
                    me.emitir.solicitante_correo = respuesta.solicitante_correo;
                    me.emitir.solicitante_direccion = respuesta.solicitante_direccion;

                    me.emitir.emitir_id = respuesta.emitir_id;
                    me.emitir.emicion_detalle = respuesta.emicion_detalle;
                    /*datos vehiculo */
                    me.emitir.id_vehiculo = respuesta.id_vehiculo;
                    me.emitir.vehiculo_nombre = respuesta.vehiculo_nombre;
                    me.emitir.vehiculo_placa = respuesta.vehiculo_placa;
                    me.emitir.valor_asegurado = Number(respuesta.valor_asegurado);
                    me.emitir.tasa_casco = respuesta.tasa_casco;
                    /*Datos Extras */
                    me.emitir.detalle = respuesta.detalle;
                    me.emitir.extra_valor = Number(respuesta.extra_valor);
                    me.emitir.extra_tasa = respuesta.extra_tasa;
                    /*Beneficios adicionales*/
                    me.emitir.cero_deducible = respuesta.cero_deducible;
                    me.emitir.auto_sustituto = respuesta.auto_sustituto;
                    me.emitir.amparo_patrimonial = respuesta.amparo_patrimonial;
                    me.emitir.lucro_cesante = respuesta.lucro_cesante;
                    /*producto */
                    me.emitir.id_seguro = respuesta.id_seguro;
                    me.emitir.seguro_nombre = respuesta.seguro_nombre;
                    me.emitir.cotizacion_aprobada = respuesta.cotizacion_aprobada;
                    /*Opciones de pago */
                    me.emitir.valor_cancelar = respuesta.valor_cancelar;
                    me.emitir.forma_pago = respuesta.forma_pago;
                    me.emitir.comision_broker = Number(respuesta.comision_broker);
                    me.emitir.numero_cuotas = respuesta.numero_cuotas;
                    /*Factura*/
                    me.emitir.factura_favor = respuesta.factura_favor;
                    me.emitir.factura_con = respuesta.factura_con;
                    /*Endoso beneficiario */
                    me.emitir.institucion = respuesta.institucion;
                    me.emitir.ruc = respuesta.ruc;
                    me.emitir.monto = respuesta.monto;
                    /*Poliza de vida */
                    me.emitir.poliza_monto = respuesta.poliza_monto;
                    me.emitir.poliza_tasa = respuesta.poliza_tasa;
                    me.emitir.poliza_valor_cancelar = respuesta.poliza_valor_cancelar;
                    me.emitir.poliza_endoso = respuesta.poliza_endoso;
                    /*Notas */
                    me.emitir.notas = respuesta.notas;
                    me.emitir.id_cotizacion = respuesta.id_cotizacion;

                    me.abrirModalEmitir();
                    me.openCargando(true);

                })
                .catch(error => {
                    me.openCargando(true);
                    console.log(error);
                    /*if (error.response.status == 401) {
                        if (localStorage['authUser']) {
                            me.$router.push({name: 'login'})
                            location.reload();
                            localStorage.clear();
                        }
                    }*/
                })
        },

        agregarHijosConyugue() {
            if (this.dataHijosConyugues.nombre === '' || this.dataHijosConyugues.apellido === '' || this.dataHijosConyugues.fecha_nacimiento === null) {
                this.notify(" " + 'Ingrese todos los datos del hijo a registrar', "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')
            } else {
                this.listHijosConyugue.push({
                    'id': 0,
                    'nombre': this.dataHijosConyugues.nombre,
                    'apellido': this.dataHijosConyugues.apellido,
                    'cumpleanio': this.dataHijosConyugues.fecha_nacimiento
                });

                this.dataHijosConyugues.nombre = '';
                this.dataHijosConyugues.apellido = '';
                this.dataHijosConyugues.fecha_nacimiento = null;
            }
        },

        calcularEdad(fecha) {
            var hoy = new Date();
            var cumpleanos = new Date(fecha);
            var edad = hoy.getFullYear() - cumpleanos.getFullYear();
            var m = hoy.getMonth() - cumpleanos.getMonth();

            if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
                edad--;
            }
            if (edad < 0) { edad = 0; }
            return edad;
        },

        eliminar_hijo(index) {
            let me = this;
            me.listHijosConyugue.splice(index, 1);
        },

        setRegistrarDatosEmitir() {
            var me = this;
            var url = '/cotizacion/emitirstore';
            this.openCargando();

            axios.post(url, {
                'emitir': this.emitir,
            }).
                then(res => {

                    if (res.data.status) {
                        me.openCargando(true);
                        me.notify(" Datos de emicion registrados con éxito", "", "top", "center", "fas fa-check-circle", "success", ' flipInX', 'flipOutX')
                        //me.cleanVariables();
                    } else {
                        me.openCargando(true);
                        me.notify(" Error al registrar", "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')
                        console.error(res.data.mensaje);
                    }

                })
                .catch(error => {
                    me.openCargando(true);//Desactivamos ventana de carga de bloqueo

                    for (var key in error.response.data.errors) {
                        me.notify(" " + error.response.data.errors[key], "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')
                    }
                    if (error.response.status == 401) {
                        if (localStorage['authUser']) {
                            me.$router.push({ name: 'login' })
                            location.reload();
                            localStorage.clear();
                            me.openCargando(true);//Desactivamos ventana de carga de bloqueo
                        }
                    }
                    console.error(error);
                }
                )
        },

        cleanVariablesEmitir() {
            let me = this;
            /*Asegurado */
            me.emitir.id_cliente = 0;
            me.emitir.asegurado_nombre = '';
            me.emitir.asegurado_cedula = '';
            me.emitir.asegurado_telefono = '';
            me.emitir.asegurado_correo = '';
            me.emitir.asegurado_direccion = '';
            /*Beneficiario */
            me.emitir.beneficiario_id = 0;
            me.emitir.beneficiario_nombre = '';
            me.emitir.beneficiario_cedula = '';
            me.emitir.beneficiario_telefono = '';
            me.emitir.beneficiario_correo = '';
            me.emitir.beneficiario_direccion = '';
            /*Solicitante */
            me.emitir.solicitante_id = 0;
            me.emitir.solicitante_nombre = '';
            me.emitir.solicitante_cedula = '';
            me.emitir.solicitante_telefono = '';
            me.emitir.solicitante_correo = '';
            me.emitir.solicitante_direccion = '';

            me.emitir.emitir_id = 0;//Tipo de documento
            me.emitir.emicion_detalle = '';

            /*datos vehiculo */
            me.emitir.id_vehiculo = 0;
            me.emitir.vehiculo_nombre = '';
            me.emitir.vehiculo_placa = '';
            me.emitir.valor_asegurado = 0.0;
            me.emitir.tasa_casco = 0.0;
            /*Datos Extras */
            me.emitir.detalle = '';
            me.emitir.extra_valor = 0.0;
            me.emitir.extra_tasa = 0.0;
            /*Beneficios adicionales*/
            me.emitir.cero_deducible = 'NO';
            me.emitir.auto_sustituto = 'NO';
            me.emitir.amparo_patrimonial = 'NO';
            me.emitir.lucro_cesante = 'NO';
            /*producto */
            me.emitir.id_seguro = 0;
            me.emitir.seguro_nombre = 0;
            me.emitir.cotizacion_aprobada = '';
            /*Opciones de pago */
            me.emitir.valor_cancelar = 0.0;
            me.emitir.forma_pago = 'CONTADO';
            me.emitir.comision_broker = 0.0;
            me.emitir.numero_cuotas = '';

            /*Factura*/
            me.emitir.factura_favor = '';
            me.emitir.factura_con = 0;

            /*Endoso beneficiario */
            me.emitir.institucion = '';
            me.emitir.ruc = '';
            me.emitir.monto = 0.0;

            /*Poliza de vida */
            me.emitir.poliza_monto = 0.0;
            me.emitir.poliza_tasa = 0.0;
            me.emitir.poliza_valor_cancelar = 0.0;
            me.emitir.poliza_endoso = '';
            /*Notas */
            me.emitir.numero_cuotas = '';
            me.emitir.id_cotizacion = 0;

        },

        pdfEmitir(id) {

            this.openCargando();
            window.open( /* this.ruta + */ '/cotizacion/pdf-emitir/' + id + ',' + '_blank');
            this.openCargando(true);
        },

        activarHoveEstado(data) {

            if (this.active_estado == data && this.active_estado != '0') {
                this.active_estado = '0';
            } else {
                this.active_estado = data;
            }

            this.getListCotizaciones(1, this.pag_mostrar);

        },

        limpiar_filtros() {
            this.active_estado = '0';
            this.filtro_cliente = '';
            this.filtro_cedular = '';
            this.filtro_asesor = 0;
            this.filtro_placa = '';
            this.filtro_referencia = 0
            this.filtro_fecha = null;
            this.filtro_mes_anio = null;
            this.filtro_ramo = null;
            this.pag_mostrar = 5;
            this.getListCotizaciones(1, this.pag_mostrar);
        },

        abrilModalImpotarExcel() {
            let me = this;
            me.modalShowExcel = !this.modalShowExcel;
            if (me.modalShowExcel != true) {
                me.excel_cotizacion = '';
                $("#file").val('');
            }
        },

        importarExcel() {

            let me = this;
            let formData = new FormData();
            formData.append('file', me.excel_cotizacion);
            this.openCargando();
            var url = '/cotizacion/import';
            //Hacemos la peticion
            axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(res => {
                    this.openCargando(true);
                    var respuesta = res.data;

                    if (respuesta.status) {
                        //me.$notie.alert(1, 'Requerimientos Importados Correctamente', 3);
                        this.notify("Cotizacion importada correctamente", "", "top", "center", "fas fa-check-circle", "success", ' flipInX', 'flipOutX')
                        me.abrilModalImpotarExcel();
                        this.getListCotizaciones(1, this.pag_mostrar);
                    } else {
                        this.notify("Error al importar las cotizaciones ", "", "top", "center", "fas fa-check-circle", "success", ' flipInX', 'flipOutX')
                    }

                })
                .catch(error => {
                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo

                    for (var key in error.response.data.errors) {
                        this.notify(" " + error.response.data.errors[key], "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')

                    }
                    if (error.response.status == 401) {
                        this.$router.push({ name: 'login' })
                        location.reload();
                        localStorage.clear();
                        this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                    console.error(error);
                })

        },

        fileUploadeExcel(e) {
            let me = this;
            let file_input = e.target.files[0];
            me.excel_cotizacion = file_input
        },

        asignarValorMercado(id) {

            if (id == 0 || id == '0') {
                this.vaCreCoti.suma_asegurada = 0.0;
            } else {
                const monto = this.arrayValorMercado.find(element => element.id == id);

                ;
                this.vaCreCoti.suma_asegurada = monto.valor_mercado;
            }
        },

        async cambiarAsesor(cotizacion_id, asesor_id) {
            //console.log(cotizacion_id, asesor_id);
            let me = this;
            try {
                var url = '/cotizacion/cambiar-asesor';
                let get = {
                    'cotizacion_id': cotizacion_id,
                    'asesor_id': asesor_id,
                };
                me.openCargando();
                let response = await axios.get(url, { params: get });
                me.openCargando(true);
                me.notify(" Nuevo Asesor Asignado", "", "top", "center", "fas fa-check-circle", "success", ' flipInX', 'flipOutX')
            } catch (error) {
                console.log(error);
                if (error.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({ name: 'login' })
                        location.reload();
                        localStorage.clear();
                    }
                }
            }
        },

        tranferencia() {
            EventBus.$emit('tranferencia-modal', 1);
        },

        formatoFechaSeguimiento(fecha, formato = 'D [de] MMMM [del]  YYYY h:mm:ss a') {
            return moment(fecha).format(formato)
        },

        exportReport() {
            let params = {
                'lista_datos_exportar' : JSON.stringify(this.lista_datos_exportar),
                'filtro_mes_anio_export' : this.filtro_mes_anio_export
            };
            let paramString = new URLSearchParams(params);

            window.open('/cotizacion/lista-export' + `?${paramString.toString()}`);
        },

        consultarDatos: _.debounce(async function ()
                {

                    let me = this;
                    let numero          = me.vaCreCliente.cNumDoc;
                    let tipo_documento  = me.vaCreCliente.eIdDocumento;

                    if(!_.isEmpty(numero)){

                        const documento = me.aTipoDocumento.filter(d => d.id == tipo_documento);
                        const aux = documento[0];

                        if(numero.length == aux.tamanio){
                            this.document.estado = false

                            try {
                                me.bloquar_input_natural = true
                                var url = '/clientes/informacion-api';
                                let post = {
                                    'numero_documento'  : numero,
                                    'documento_id'      : tipo_documento
                                }
                                let response        = await axios.post(url, post);
                                var respuesta       = response.data;

                                if(respuesta.success){

                                        let pal = respuesta.data.razon_social.split(' ');

                                       if(pal.length >= 4 ){
                                            me.vaCreCliente.cNombre                      = pal[2] + ' ' + pal[3]
                                            me.vaCreCliente.cApellido                    = pal[0] + ' ' + pal[1]
                                        }else{
                                            me.vaCreCliente.cNombre                      = respuesta.data.razon_social
                                        }
                                        var data_c =  respuesta.data
                                        me.vaCreCliente.cDireccion                   = respuesta.data.direccion
                                        this.vaCreCliente.genero                    = (data_c.genero == 'MUJER') ? 'Femenino' : 'Masculino'
                                        this.vaCreCliente.fecha_nacimiento          = data_c.fechaNacimiento
                                        this.vaCreCliente.estado_civil              = (data_c.estadoCivil == 'CASADO') ? 'Casado' : 'Soltero'
                                        this.vaCreCliente.nombre_conyugue           = data_c.conyuge
                                }else{
                                    //me.lista_errores.numero_documento = respuesta.message
                                }

                                me.bloquar_input_natural = false

                            } catch (error) {
                                me.bloquar_input_natural = false
                            }
                        }else{
                            this.document =  {
                                    error : 'El minimo y máximo de caracteres es de ' + aux.tamanio,
                                    estado : true,
                                }
                        }
                    }

                }, 500
        ),
        consultarPlacaAnt() {

                 this.notify("Verificar la Placa en ANT: ", "", "top", "center", "fas fa-exclamation-triangle", "warning");
                 let numero = this.vaCreCoti.placa;

                   if(!_.isEmpty(numero)){
                     if(numero.length >= 6){


                        this.loading = true;
                        this.vehiculo = null;

                        axios.get('/vehiculo/consultar', { params: { placa: this.vaCreCoti.placa } })
                            .then(res => {
                                if (res.data.success) {
                                    this.vehiculo = res.data.data;

                                     let marca = this.vehiculo.marca;
                                    //this.notify("la modelo es : "+this.vehiculo.modelo, "", "top", "center", "fas fa-exclamation-triangle", "warning");
                                      const existe = this.arrayMarcas.find(m => m.nombre == marca);
                                      console.log("existe la marca :"+existe.id );
                                      this.nombrebuscarmodelo=this.vehiculo.modelo;

                                        if(existe)
                                        {
                                            //GTB1585
                                             console.log("existe la marca entro al if:" );
                                              this.buscarmodelo=true;
                                            this.selectVehiculos(existe.id);

                                            this.vaCreCoti.idmarca = existe.id
                                        }else{

                                             this.notify("la marca no existe : ", "", "top", "center", "fas fa-exclamation-triangle", "warning");

                                        }

                                         //modelo
                                        let modelo = this.vehiculo.modelo

                                        console.log("el modelo del carro es :"+modelo);

                                        //const existe_m = this.arrayVehiculo.find(m => m.nombre == modelo.toUpperCase().trim());
                                        this.arrayVehiculo.forEach(vehiculo => console.log(vehiculo));
                                        console.table(this.arrayVehiculo);
                                        const existe_m = this.arrayVehiculo.find(m => m.nombre.toUpperCase().includes(modelo.toUpperCase().trim()));

                                        if(existe_m){
                                            //GTB1585
                                            this.vaCreCoti.idVehiculo = existe_m.id
                                               console.log("existe modelo del carro  :"+existe_m.id);
                                        }else{
                                              console.log("no existe modelo del carro  :");

                                        }
                                       // this.nombre_modelo = existe_m.nombre
                                       let anio_vehiculo = this.vehiculo.anio
                                       const existe_a = this.arrayAnios.filter(m => m.anio == anio_vehiculo);
                                        //this.existe_a.forEach(vehiculoanio => console.log(vehiculoanio.anio));
                                       console.table(this.existe_a);

                                         if(existe_a){

                                              console.log("Estructura completa de existe_a:", existe_a);
                                                this.vaCreCoti.modelo_anios_id = existe_a[0].id

                                            //  console.log("existe año del carro: " + existe_a[0].anio + " - " + existe_a[0].id);

                                        }else{
                                              console.log("no existe año del carro  :");

                                        }

                                        let servicio_vehiculo = this.vehiculo.servicio;
                                        console.log("la clase vehiculo es :"+servicio_vehiculo);

                                        //Cargar el servicio
                                        //this.arrayTipoUso.forEach(tipo_uso => console.log(tipo_uso));

                                  /* let aux_tipo       = this.arrayTipoUso.filter(m => m.nombre == vehiculo.descripcion_servicio);
                                    if(aux_tipo.length >= 1){
                                        this.vaCreCoti.idTipoUso = aux_tipo[0].id
                                    }

                                    */
                                    let nombre_servicio="";
                                    if (servicio_vehiculo ==="USO PARTICULAR")
                                    {
                                        nombre_servicio="PARTICULAR";

                                    }
                                    if (servicio_vehiculo ==="USO COMERCIAL")
                                    {
                                        nombre_servicio="COMERCIAL";

                                    }

                                       let aux_tipo = this.arrayTipoUso.find(m => m.nombre.toUpperCase().includes(nombre_servicio.toUpperCase().trim()));

                                    if(aux_tipo){
                                        //this.vaCreCoti.idTipoUso = aux_tipo[0].id
                                        this.vaCreCoti.idTipoUso = aux_tipo.id;
                                         console.log("existe el servicio del vehiculo  :");
                                    }else{
                                        console.log("no existe el servicio del vehiculo  :");

                                    }














                                } else {
                                    this.notify(res.data.message, "", "top", "center", "fas fa-info-circle", "warning");0
                                }
                            })
                            .catch(err => {
                                console.error(err);
                                this.notify("Error al conectar con la ANT o placa no encontrada:"+err, "", "top", "center", "fas fa-times", "danger");
                            })
                            .finally(() => { this.loading = false; });


                     }
                     else
                     {
                        this.notify("La Placa Minimo debe contener 6 digitos: ", "", "top", "center", "fas fa-exclamation-triangle", "warning");
                     }
                   }else
                   {
                    this.notify("Ingrese una placa", "", "top", "center", "fas fa-exclamation-triangle", "warning");
                    return;
                   }


        },

        consultarPlaca: _.debounce(async function ()
                {

                    let me = this;
                    let numero          = me.vaCreCoti.placa

                this.notify("Se esta ejecutando: "+numero, "", "top", "center", "fas fa-exclamation-triangle", "warning");

                    if(!_.isEmpty(numero)){


                        if(numero.length >= 6){
                            this.document.estado = false

                            try {
                                me.bloquear_input_placa = true
                                var url = 'consultar-placa';
                                let post = {
                                    'numero_placa'  : numero,
                                }
                                let response        = await axios.post(url, post);
                                var respuesta       = response.data;

this.notify("respuesta es : "+respuesta.data.vehiculo_modelo, "", "top", "center", "fas fa-exclamation-triangle", "warning");
                                console.log("estos son los datos del objeto de la placa: "+respuesta.data.vehiculo_modelo);

                                if(respuesta.success){
                                    if(respuesta.data.vehiculo_marca != undefined){
                                        //Marca

                                        let marca = respuesta.data.vehiculo_marca
                                        this.notify("la Marca es "+marca, "", "top", "center", "fas fa-exclamation-triangle", "warning");

                                        const existe = me.arrayMarcas.filter(m => m.id == marca.id);

                                        if(existe.length >= 1){
                                            //GTB1585
                                            me.vaCreCoti.idmarca = marca.id
                                        }else{
                                            me.arrayMarcas.push({
                                                id: marca.id,
                                                nombre: marca.nombre
                                            })
                                            me.vaCreCoti.idmarca = marca.id
                                        }
                                        //modelo
                                        let modelo = respuesta.data.vehiculo_modelo
                                        const existe_m = me.arrayVehiculo.filter(m => m.id == modelo.id);

                                        if(existe_m.length >= 1){
                                            //GTB1585
                                            me.vaCreCoti.idVehiculo = modelo.id
                                        }else{
                                            me.arrayVehiculo.push({
                                                id: modelo.id,
                                                nombre: modelo.nombre
                                            })
                                            me.vaCreCoti.idVehiculo = modelo.id
                                        }

                                        me.nombre_modelo = modelo.nombre


                                        //anio
                                        let anio = respuesta.data.vehiculo_anio
                                        const existe_a = me.arrayAnios.filter(m => m.id == anio.id);

                                        if(existe_a.length >= 1){
                                            //GTB1585
                                            me.vaCreCoti.modelo_anios_id = anio.id
                                        }else{
                                            me.arrayAnios.push({
                                                id: anio.id,
                                                anio: anio.anio
                                            })
                                            me.vaCreCoti.modelo_anios_id = anio.id
                                        }

                                    }

                                    let vehiculo    = respuesta.data
                                    //console.log(vehiculo);
                                    let aux_tipo       = me.arrayTipoUso.filter(m => m.nombre == vehiculo.descripcion_servicio);

                                    if(aux_tipo.length >= 1){
                                        me.vaCreCoti.idTipoUso = aux_tipo[0].id
                                    }

                                }

                                me.bloquear_input_placa = false

                            } catch (error) {
                                me.bloquear_input_placa = false
                            }
                        }
                    }

                }, 500
        ),

        validarDatosSweaden(){
            let estado = false;

            if (!this.nombreSeguro.some(objeto => objeto.nombre.toLowerCase() === "sweaden")) {
            return estado;
            }

            if(this.vaCreCoti.suma_asegurada <= 0){
                this.notify(" Sweaden requiere una suma asegurada", "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')
                estado = true
            }

            if(this.vaCreCoti.fecha_nacimiento == null){
                this.notify(" El cliente seleccionado no cuenta con una fecha de nacimiento", "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')
                estado = true
            }

            let anios = this.arrayAnios.filter(a => a.id == this.vaCreCoti.modelo_anios_id);

            let anio  = (anios.length >= 1) ? anios[0].anio : 0

            this.vaCreCoti.anio_vehiculo = anio;

            if(anio == undefined || anio == 0){
                this.notify(" El año del vehículo es incorrecto", "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')
                estado = true
            }

            if(![1, 2, 3].includes(this.vaCreCoti.categoria_vehiculo)){
                this.notify(" El tipo de vehículo no corresponde a Sweaden", "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')
                estado = true
            }

            if(this.vaCreCoti.fecha_inicio == null){
                this.notify("Sweaden necesita la fecha de vigencia de inicio", "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')
                estado = true
            }

            if(this.vaCreCoti.fecha_fin == null){
                this.notify(" Sweaden necesita la fecha de vigencia de finalización", "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')
                estado = true
            }

            return estado
        },

        compararEstado() {
            const lista = [
                "RECOLECION DE DOCUMENTOS",
                "GESTION DE INSPECCION",
                "GESTION DE EMISION",
                "GESTION DE LIBERACION",
                "PRELIQUIDACION"
            ];

            return lista.includes(this.vaCreCoti.estado) && (this.vaCreCoti.placa === null || this.vaCreCoti.placa === '');
        },

        verHistorial(cotizacion_id) {
            this.$router.push({ name: 'historial_cotizaciones.index', params: { id: cotizacion_id } });
        },

        getNombreArchivo(url) {
            return url ? url.split('/').pop() : '';
        }

    },
    mounted() {

        this.getSelectTipoDoc();
        this.getDataUser();
        this.getListCotizaciones(this.pagination.current_page, this.pag_mostrar);
    },
}
</script>

<style>
.breadcrumb {
    display: flex;
    margin: auto;
    text-align: center;
    font-size: 18px;
    flex-wrap: wrap;
    padding: .75rem 1rem;
    list-style: none;
    background-color: #ffffff;
    border-radius: .25rem;
    min-width: 3000px;
}

.breadcrumb a {
    position: relative;
    display: flex;
    flex-grow: 1;
    text-decoration: none;
    background-color: none !important;
    padding-left: 38px;
    color: #fff;
    height: 64px;
}

.breadcrumb a:first-child {
    padding-left: 15.2px;
}

.breadcrumb a:last-child {
    padding-right: 15.2px;
}

.breadcrumb a:after {
    content: "";
    position: absolute;
    display: inline-block;
    width: 63px;
    height: 63px;
    /* top: 0; */
    right: -31.1481481481px;
    border-top-right-radius: 5px;
    transform: scale(0.707) rotate(45deg);
    z-index: 1;
    bottom: 0.1px;
}

.breadcrumb a:last-child:after {
    content: none;
}

.breadcrumb__inner {
    display: flex;
    flex-direction: column;
    margin: auto;
    z-index: 2;
    min-width: 78px;
}

.breadcrumb__title {
    font-weight: bold;
}



@media all and (max-width: 1000px) {
    .breadcrumb {
        font-size: 12px;
    }
}

@media all and (max-width: 710px) {


    .breadcrumb {
        height: 90px;
    }

    .breadcrumb a {
        padding-left: 25.3333333333px;
    }

    .breadcrumb a:after {
        content: "";
        width: 38px;
        height: 38px;
        right: -19px;
        transform: scale(0.707) rotate(45deg);
    }
}


.hoveractive:hover::before {
    position: absolute;
    display: block;
    width: 50px;
    top: 80%;
    margin-top: -29px;
    margin-left: -25px;
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    content: "\f039";
    padding-right: 5px;
}

.hoveractive.active::before {
    position: absolute;
    display: block;
    width: 50px;
    top: 80%;
    margin-top: -29px;
    margin-left: -25px;
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    content: "\f039";
    padding-right: 5px;
}

.primero {
    background-color: #F44336;
}

.segundo {
    background-color: #FF4081;
}

.tercero {
    background-color: #E040FB;
}

.cuarto {
    background-color: #673AB7;
}

.quinto {
    background-color: #536DFE;
}

.sexto {
    background-color: #1976D2;
}

.septimo {
    background-color: #2196F3;
}

.octavo {
    background-color: #00BCD4;
}

.noveno {
    background-color: #4CAF50;
}

.decimo {
    background-color: #8BC34A;
}

.primero-2 {
    background-color: #CDDC39;
}

.segundo-2 {
    background-color: #FFC107;
}


.breadcrumb .primero::after {
    background-color: #F44336;
}

.breadcrumb .segundo::after {
    background-color: #FF4081;
}

.breadcrumb .tercero::after {
    background-color: #E040FB;
}

.breadcrumb .cuarto::after {
    background-color: #673AB7;
}

.breadcrumb .quinto::after {
    background-color: #536DFE;
}

.breadcrumb .sexto::after {
    background-color: #1976D2;
}

.breadcrumb .septimo::after {
    background-color: #2196F3;
}

.breadcrumb .octavo::after {
    background-color: #00BCD4;
}

.breadcrumb .noveno::after {
    background-color: #4CAF50;
}

.breadcrumb .decimo::after {
    background-color: #8BC34A;
}

.breadcrumb .primero-2::after {
    background-color: #CDDC39;
}

.breadcrumb .segundo-2::after {
    background-color: #FFC107;
}

th b {
    font-weight: bolder;
    color: blue;
    font-size: 17px;
}

.el-select.bjar {
    width: 100% !important;
}

.el-select.bjar .el-input {
    width: 100% !important;
}

#ptable tbody td p {
    margin-bottom: 0px !important;
}

p.ciruclo-p {
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    background: #28a745;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: 0px auto;
    color: white;
}

a.btn.btn-rounded.btn-outline-success.mb-2.mr-2 {
    font-size: 14px;
}

.hover-eti :hover {
    color: #3498DB;
}
</style>
